// ArticlesSVG
// ReferencesSVG
// ProductListsSVG
// LeadManagementSVG
// UserManagementSVG
// ThreeDViewerSVG
// NotFoundSVG
// BackupSVG
// CMSTreeSVG
// ProductsSVG
// SalesListSVG
// SelectSVG
// StaticPagesSVG
// TagsSVG
// SVGs in this file:
// UserSVG               ImagePlaceholderSVG
// ArrowSVG              CrossSVG
// TikSVG                TrashCanSVG
// ThreeDotsSVG          PlusSVG
// ExpandAllSVG          CollapseAllSVG
// InfoSVG               SearchSVG
// FarbinLogoSVG         FarbinPlaceholderSVG
// SupportSVG            SupportV2SVG
// ContactUsSVG
// SignoutSVG            ContractSVG
// HeartSVG              CategorySVG
// EditSVG               SolutionSVG
// BulletSVG             DividerSVG
// DoubleQuoteSVG        FaqSVG
// HeadingSVG            ImageSVG
// ParagraphSVG          ProductListSVG
// ReferenceSVG          TableSVG
// OverlaySVG            ArticlePlaceholderSVG
// UrlSVG                VideoSVG
// ReorderSVG            PasteSVG
// CopySVG               LoadImageSVG
// TagSVG                CalendarSVG
// TimeSVG               SettingsAltSVG
// CaptionSVG
// CallSVG               EmailSVG
// FavSVG                HSLogoSVG
// LocationSVG           PlacementSVG
// WebSVG                ZipcodeSVG
// ArrowGraySVG          ArrowPinkSVG
// RowInsertBottomSVG    RowInsertTopSVG
// RowRemoveSVG          FreezeRowSVG
// ColumnInsertLeftSVG   ColumnInsertRightSVG
// ColumnRemoveSVG       FreezeColumnSVG
// ControlPanelSVG       MediaExplorerSVG

const colorMap: Record<string, string> = {
  white: "#fff",
  black: "#000",
  slateCustom: "var(--color-slateCustom)",
  grayCustom: "var(--color-grayCustom)",
  pinkCustom: "var(--color-pinkCustom)",
  blueCustom: "var(--color-blueCustom)",
};

const resolveColor = (name?: string) =>
  name ? colorMap[name] ?? name : undefined;

type TablerTableIconProps = {
  className?: string;
  svgColor?: string;
};

const getTablerStroke = (svgColor?: string) =>
  resolveColor(svgColor) ?? "currentColor";

export const RowInsertBottomSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1" />
    <path d="M12 15l0 4" />
    <path d="M14 17l-4 0" />
  </svg>
);

export const RowInsertTopSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1" />
    <path d="M12 9v-4" />
    <path d="M10 7l4 0" />
  </svg>
);

export const RowRemoveSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1" />
    <path d="M10 16l4 4" />
    <path d="M10 20l4 -4" />
  </svg>
);

export const FreezeRowSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14" />
    <path d="M21 9h-18" />
    <path d="M15 3l-6 6" />
    <path d="M9.5 3l-6 6" />
    <path d="M20 3.5l-5.5 5.5" />
  </svg>
);

export const ColumnInsertLeftSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1" />
    <path d="M5 12l4 0" />
    <path d="M7 10l0 4" />
  </svg>
);

export const ColumnInsertRightSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1" />
    <path d="M15 12l4 0" />
    <path d="M17 10l0 4" />
  </svg>
);

export const ColumnRemoveSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1" />
    <path d="M16 10l4 4" />
    <path d="M16 14l4 -4" />
  </svg>
);

export const FreezeColumnSVG = ({
  className,
  svgColor,
}: TablerTableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={getTablerStroke(svgColor)}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M9 9.5l-6 6" />
    <path d="M9 4l-6 6" />
    <path d="M9 15l-5 5" />
    <path d="M9 3v18" />
    <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14" />
  </svg>
);

export const UserSVG = ({
  className,
  accentColor = "var(--color-gray-500)",
  svgColor = "pinkCustom",
}: {
  className: string;
  accentColor?: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 172.17 201.59"
      className={className}
    >
      <path
        fill={resolveColor(accentColor)}
        d="M82.65.6c31.57-2.03,57.72,24.15,55.69,55.78-1.68,26.13-22.75,47.23-48.84,48.89-31.56,2.01-57.67-24.15-55.66-55.75C35.49,23.38,56.56,2.27,82.65.6Z"
      />
      <path
        fill={resolveColor(svgColor)}
        d="M86.08,201.41c-30.89,0-59.05-11.6-80.43-30.68-6.52-5.82-7.56-15.65-2.3-22.63,9.88-13.11,22.84-23.88,37.61-31.05,6.52-3.16,14.13-3.11,20.88.13,7.6,3.66,15.76,5.51,24.25,5.51s16.64-1.86,24.25-5.51c6.76-3.25,14.37-3.3,20.88-.13,14.77,7.17,27.72,17.94,37.61,31.05,5.26,6.98,4.22,16.81-2.3,22.63-21.38,19.08-49.54,30.68-80.43,30.68Z"
      />
    </svg>
  );
};

export const ImagePlaceholderSVG = ({
  className,
  bgColor = "white",
  svgColor = "slateCustom",
}: {
  className: string;
  bgColor?: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 165.38 165.38"
    className={className}
  >
    <rect
      fill={resolveColor(svgColor)}
      y=".28"
      width="165.38"
      height="165.11"
      rx="6.33"
      ry="6.33"
    />
    <path
      fill={resolveColor(bgColor)}
      d="M145.66,152.37H20.29c-3.98,0-7.22-3.21-7.22-7.18V20.47c0-3.96,3.23-7.18,7.22-7.18h125.37c3.99,0,7.22,3.21,7.22,7.18v124.73c0,3.96-3.23,7.18-7.22,7.18Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M76.43,63.89c-.14-11-8.26-19.07-19.06-18.94-10.09,.12-19.06,9.3-18.78,19.24,.29,10.17,8.76,18.75,18.43,18.65,11.54-.12,19.55-7.94,19.41-18.94Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M124.57,87.36c-34.7-.04-28.09,24.43-78.96,24.77-14.11,.09-24.91-5.81-32.54-12.35v45.41c0,3.96,3.23,7.18,7.22,7.18h125.37c3.99,0,7.22-3.21,7.22-7.18v-53.9c-7.62-2.2-17.12-3.92-28.31-3.93Z"
    />
  </svg>
);

export const ArrowSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5.1 8.7"
    className={className}
  >
    <polyline
      stroke={resolveColor(svgColor)}
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      points="0.6,8.2 4.4,4.4 0.6,0.5"
    />
  </svg>
);

export const ArrowGraySVG = ({
  className,
  svgColor = "grayCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 4.95 4.55"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M1.52,1.6h-.44V3.62h.44c.79-.23,1.58-.46,2.38-.7,.25-.21,.25-.41,0-.6L1.52,1.6Z"
    />
  </svg>
);

export const ArrowPinkSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 4.95 4.55"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M.77,.6H3.71c.33,0,.6,.27,.6,.6v2.85c0,.13-.15,.19-.24,.1L.67,.85c-.09-.09-.03-.24,.1-.24"
    />
  </svg>
);

export const CrossSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 5.95 5.95"
      className={className}
    >
      <path
        fill={resolveColor(svgColor)}
        d="M5.9,.7L5.25,.05c-.07-.07-.19-.07-.26,0l-1.89,1.89c-.07,.07-.19,.07-.26,0L.96,.05c-.07-.07-.19-.07-.26,0L.05,.7c-.07,.07-.07,.19,0,.26l1.89,1.89c.07,.07,.07,.19,0,.26L.05,4.99c-.07,.07-.07,.19,0,.26l.65,.65c.07,.07,.19,.07,.26,0l1.89-1.89c.07-.07,.19-.07,.26,0l1.89,1.89c.07,.07,.19,.07,.26,0l.65-.65c.07-.07,.07-.19,0-.26l-1.89-1.89c-.07-.07-.07-.19,0-.26l1.89-1.89c.07-.07,.07-.19,0-.26Z"
      />
    </svg>
  );
};

export const TikSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    className={className}
    viewBox="0 0 7.73 5.65"
  >
    <path
      fill={resolveColor(svgColor)}
      d="M7.69,.85L6.88,.04s-.13-.05-.18,0L3.08,3.65s-.13,.05-.18,0L1.03,1.77s-.13-.05-.18,0L.04,2.59s-.05,.13,0,.18l2.87,2.84c.06,.06,.15,.06,.21,0L7.69,1.03s.05-.13,0-.18Z"
    />
  </svg>
);

export const TrashCanSVG = ({
  className,
  svgColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 179.4 221.24"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M19.09,60.71c5.48-.48,10.13,3.69,10.84,9.01l.12,114.3c1.54,8.85,8.4,15.31,17.38,16.25l85.01-.02c9.22-1.22,16.11-8.21,17.07-17.49l.02-113.46c2.89-12.3,18.95-11.08,20.06,1.81l-.02,111.63c-1.45,21.07-17.1,36.25-38.06,37.6-27.21,1.75-56.21-1.32-83.61.02-21.51-1.42-36.82-17.03-38.06-38.53-2.1-36.31,1.62-74.64.03-111.17.24-4.91,4.24-9.5,9.24-9.95Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M129.4,30.72h40.86c1.53,0,5.18,1.87,6.3,3.04,6.16,6.39,1.6,17.03-7.22,17.06l-160.63-.06c-8.11-1.18-11.64-11.02-5.87-17,1.13-1.17,4.77-3.04,6.3-3.04h40.86V8.54c0-.21,1.21-2.79,1.48-3.19,1.67-2.57,4.74-3.95,7.68-4.46,19.43,1,40.5-1.51,59.75-.07,3.47.26,7.04,1.5,9.01,4.53.27.41,1.48,2.99,1.48,3.19v22.18ZM109.79,20.91h-40.16v9.81h40.16v-9.81Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M68.11,80.82c6.9-.96,11.29,3.84,11.81,10.37,1.74,22.21-1.33,46.68-.02,69.13-1.27,13.48-19,13.1-20.09.49-1.96-22.63,1.5-48.07.02-71,.35-4.4,3.88-8.37,8.29-8.99Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M107.8,80.81c6.17-1.03,11.33,3.31,11.82,9.44l-.06,71.43c-2.78,12.42-19.03,11.36-20.06-1.81-1.74-22.21,1.33-46.68.02-69.13.2-4.66,3.53-9.15,8.27-9.94Z"
    />
  </svg>
);

export const ThreeDotsSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    version="1.1"
    viewBox="0 0 22.82 4.52"
    className={className}
  >
    <g>
      <circle fill={resolveColor(svgColor)} cx="20.55" cy="2.26" r="2.26" />
      <circle fill={resolveColor(svgColor)} cx="11.4" cy="2.26" r="2.26" />
      <circle fill={resolveColor(svgColor)} cx="2.26" cy="2.26" r="2.26" />
    </g>
    <g>
      <circle fill={resolveColor(svgColor)} cx="20.55" cy="2.26" r="2.26" />
      <circle fill={resolveColor(svgColor)} cx="11.4" cy="2.26" r="2.26" />
      <circle fill={resolveColor(svgColor)} cx="2.26" cy="2.26" r="2.26" />
    </g>
  </svg>
);

export const PlusSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 130.46 130.62"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M116.17,50.94h-36.57V14.37c0-7.94-6.43-14.37-14.37-14.37s-14.37,6.43-14.37,14.37v36.57H14.29C6.35,50.94-.08,57.37-.08,65.31s6.44,14.37,14.37,14.37h36.57v36.57c0,7.94,6.43,14.37,14.37,14.37s14.37-6.43,14.37-14.37v-36.57h36.57c7.94,0,14.37-6.44,14.37-14.37s-6.44-14.37-14.37-14.37Z"
    />
  </svg>
);

export const ExpandAllSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 30.78 9.55"
    className={className}
  >
    <rect
      fill={resolveColor(svgColor)}
      x=".07"
      y="7.93"
      width="30.64"
      height="1.62"
      rx=".81"
      ry=".81"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M14.24,7.23c.64.64,1.67.64,2.31,0l5.82-5.82c.36-.36.32-.96-.11-1.27-.34-.24-.81-.17-1.1.12l-4.61,4.61c-.64.64-1.67.64-2.31,0L9.63.27c-.31-.31-.83-.37-1.17-.08-.19.17-.29.4-.29.63,0,.21.08.43.24.59l5.82,5.82Z"
    />
  </svg>
);

export const CollapseAllSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    width="30.78"
    height="9.55"
    viewBox="0 0 30.78 9.55"
    className={className}
  >
    <rect
      fill={resolveColor(svgColor)}
      x=".07"
      y="7.93"
      width="30.64"
      height="1.62"
      rx=".81"
      ry=".81"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M8.18,6.88c0,.23.1.47.29.63.34.29.85.23,1.17-.08l4.6-4.6c.64-.64,1.67-.64,2.31,0l4.61,4.61c.29.29.77.36,1.1.12.43-.31.46-.91.11-1.27L16.54.48c-.64-.64-1.67-.64-2.31,0l-5.82,5.82c-.16.16-.24.38-.24.59Z"
    />
  </svg>
);

export const InfoSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0,0,256,256"
      className={className}
    >
      <g
        fill={resolveColor(svgColor)}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
      >
        <g transform="scale(8.53333,8.53333)">
          <path d="M15,3c-6.627,0 -12,5.373 -12,12c0,6.627 5.373,12 12,12c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12zM16,21h-2v-7h2zM15,11.5c-0.828,0 -1.5,-0.672 -1.5,-1.5c0,-0.828 0.672,-1.5 1.5,-1.5c0.828,0 1.5,0.672 1.5,1.5c0,0.828 -0.672,1.5 -1.5,1.5z"></path>
        </g>
      </g>
    </svg>
  );
};

export const SearchSVG = ({ className, svgColor = "pinkCustom", accentColor = "var(--color-gray-500)" }: { className: string, svgColor?: string, accentColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 202.45 230.81"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(svgColor)}
      d="M161.06,80.87C161.06,36.58,125.04.55,80.76.55S.46,36.58.46,80.87s36.02,80.3,80.3,80.3,80.3-36.02,80.3-80.3ZM143.02,80.87c0,34.33-27.93,62.25-62.25,62.25s-62.25-27.93-62.25-62.25,27.93-62.27,62.25-62.27,62.25,27.94,62.25,62.27Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M198.41,193l-41.85-49.88-36.95,30.98,41.88,49.91c3.47,4.12,8.44,6.24,13.44,6.24,3.98,0,8-1.34,11.26-4.1l10.07-8.42c3.61-3.03,5.78-7.26,6.19-11.94.41-4.68-1.05-9.22-4.05-12.79Z"
    />
  </svg>
);

export const FarbinLogoSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 223.03 201.59"
    >
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M91.24,147.83v50.45c-.05,5.75-8.64,5.7-8.59.06v-50.51h8.59Z"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M76.62,147.98v50.33c-.34,2.72-1.89,4.04-4.36,4.27-.09,0-.16,0-.24,0h-1.28c-2.8-.29-4.2-1.87-4.17-4.77,0-.12.03-.29.04-.43,1.58-16.29,2.77-31.17,3.4-47.82l.06-1.58h6.55Z"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M64.36,147.87l-.05,1.32c-.67,17.79-1.92,33.21-3.71,49.04-.02.17-.04.35-.06.52-.62,2.35-2.13,3.62-4.51,3.82-.13.01-.27,0-.4,0h-11.39c-3.58-.73-4.78-2.89-3.84-6.32.03-.12.1-.24.15-.36,6.51-15.35,11.33-29.86,14.21-46.24l.33-1.87,9.28.08Z"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M91.24,4.35v118.23h-8.59V4.39c-.03-5.89,8.56-5.81,8.59-.04Z"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M70.78,0h1.63c2.54.32,3.93,1.7,4.21,4.11.02.18,0,.46,0,.69v117.83h-5.98s.03-1.89.03-1.89c.57-38.18-.75-75.68-4.14-115.59-.02-.19-.03-.4-.05-.59C66.71,1.81,68.17.32,70.78,0Z"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M44.16,0c.11,0,.24,0,.36,0h12.27c2.11.21,3.45,1.45,4.04,3.72.02.08.01.17.02.25,3.09,43.15,4.5,80.67,4.03,116.08l-.03,2.37-7.35.09.13-2.03c2.29-36.29-2.82-73.28-17.31-114.25-.05-.15-.11-.3-.16-.46C39.14,2.65,41.3.12,44.16,0Z"
      />
      <path
        fill={resolveColor(accentColor)}
        fillRule="evenodd"
        d="M138.76,148.24v46.97c-.14,4.46-2.78,6.66-7.08,7.38h-29.54c-4.2-.57-6.58-2.91-7.22-6.94-.04-.25,0-.53,0-.78v-46.78l43.84.15Z"
      />
      <g>
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="139.01 125.93 142.92 125.93 142.92 144.59 139.01 144.59 139.01 125.93 139.01 125.93" />
        <path fill={resolveColor(accentColor)} fillRule="evenodd" d="M22.91,126.14h3.92v18.33h-3.92c-7.08-2.1-14.16-4.21-21.23-6.31-2.24-1.87-2.23-3.66,0-5.38l21.23-6.64h0Z" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="30.2 126.14 34.12 126.14 34.12 144.47 30.2 144.47 30.2 126.14 30.2 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="69.24 126.14 73.16 126.14 73.16 144.47 69.24 144.47 69.24 126.14 69.24 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="59.27 126.14 63.19 126.14 63.19 144.47 59.27 144.47 59.27 126.14 59.27 126.14" />
        <path fill={resolveColor(accentColor)} fillRule="evenodd" d="M53.36,123.09c-3.11-.77-6.22-1.53-9.33-2.3-4.31-1.06-7.25-.32-7.19,5.36v18.33c.03,5.62,2.19,7.05,6.91,5.68l9.37-2.73c1.07-.58,1.61-1.53,1.69-2.8v-19.12c.02-1.24-.53-1.99-1.44-2.42ZM47.05,130.49l-4.08-.06-.08,10.16h4.16v3.15h-5.89v-16.31h5.89v3.07Z" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="79.21 126.14 83.13 126.14 83.13 144.47 79.21 144.47 79.21 126.14 79.21 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="89.17 126.14 93.09 126.14 93.09 144.47 89.17 144.47 89.17 126.14 89.17 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="99.14 126.14 103.06 126.14 103.06 144.47 99.14 144.47 99.14 126.14 99.14 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="109.11 126.14 113.03 126.14 113.03 144.47 109.11 144.47 109.11 126.14 109.11 126.14" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="119.07 125.93 122.99 125.93 122.99 144.59 119.07 144.59 119.07 125.93 119.07 125.93" />
        <polygon fill={resolveColor(accentColor)} fillRule="evenodd" points="129.04 125.93 132.96 125.93 132.96 144.59 129.04 144.59 129.04 125.93 129.04 125.93" />
      </g>
      <path fill={resolveColor(accentColor)} fillRule="evenodd" d="M102.46,0c.2-.02.4,0,.6,0h113.64c3.73.58,5.96,2.86,6.34,6.72v22.85c-.64,4.52-3.23,6.64-7.13,7.13h-77.13v46.14h70.19c4.15.43,6.75,2.62,7.22,7.26v22.32c-.59,4.54-3.14,6.71-7.17,7.11h-70.24v2.9l-43.84.3V7.73c.2-4.61,2.69-7.21,7.53-7.72Z" />
    </svg>
  );
};

export const FarbinPlaceholderSVG = ({
  className,
  svgColor = "#f2f2f4",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 223.03 201.59"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M91.24,147.83v50.45c-.05,5.75-8.64,5.7-8.59.06v-50.51h8.59Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M76.62,147.98v50.33c-.34,2.72-1.89,4.04-4.36,4.27-.09,0-.16,0-.24,0h-1.28c-2.8-.29-4.2-1.87-4.17-4.77,0-.12.03-.29.04-.43,1.58-16.29,2.77-31.17,3.4-47.82l.06-1.58h6.55Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M64.36,147.87l-.05,1.32c-.67,17.79-1.92,33.21-3.71,49.04-.02.17-.04.35-.06.52-.62,2.35-2.13,3.62-4.51,3.82-.13.01-.27,0-.4,0h-11.39c-3.58-.73-4.78-2.89-3.84-6.32.03-.12.1-.24.15-.36,6.51-15.35,11.33-29.86,14.21-46.24l.33-1.87,9.28.08Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M91.24,4.35v118.23h-8.59V4.39c-.03-5.89,8.56-5.81,8.59-.04Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M70.78,0h1.63c2.54.32,3.93,1.7,4.21,4.11.02.18,0,.46,0,.69v117.83h-5.98s.03-1.89.03-1.89c.57-38.18-.75-75.68-4.14-115.59-.02-.19-.03-.4-.05-.59C66.71,1.81,68.17.32,70.78,0Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M44.16,0c.11,0,.24,0,.36,0h12.27c2.11.21,3.45,1.45,4.04,3.72.02.08.01.17.02.25,3.09,43.15,4.5,80.67,4.03,116.08l-.03,2.37-7.35.09.13-2.03c2.29-36.29-2.82-73.28-17.31-114.25-.05-.15-.11-.3-.16-.46C39.14,2.65,41.3.12,44.16,0Z"
    />
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M138.76,148.24v46.97c-.14,4.46-2.78,6.66-7.08,7.38h-29.54c-4.2-.57-6.58-2.91-7.22-6.94-.04-.25,0-.53,0-.78v-46.78l43.84.15Z"
    />
    <g>
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="139.01 125.93 142.92 125.93 142.92 144.59 139.01 144.59 139.01 125.93 139.01 125.93"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M22.91,126.14h3.92v18.33h-3.92c-7.08-2.1-14.16-4.21-21.23-6.31-2.24-1.87-2.23-3.66,0-5.38l21.23-6.64h0Z"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="30.2 126.14 34.12 126.14 34.12 144.47 30.2 144.47 30.2 126.14 30.2 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="69.24 126.14 73.16 126.14 73.16 144.47 69.24 144.47 69.24 126.14 69.24 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="59.27 126.14 63.19 126.14 63.19 144.47 59.27 144.47 59.27 126.14 59.27 126.14"
      />
      <path
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        d="M53.36,123.09c-3.11-.77-6.22-1.53-9.33-2.3-4.31-1.06-7.25-.32-7.19,5.36v18.33c.03,5.62,2.19,7.05,6.91,5.68l9.37-2.73c1.07-.58,1.61-1.53,1.69-2.8v-19.12c.02-1.24-.53-1.99-1.44-2.42ZM47.05,130.49l-4.08-.06-.08,10.16h4.16v3.15h-5.89v-16.31h5.89v3.07Z"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="79.21 126.14 83.13 126.14 83.13 144.47 79.21 144.47 79.21 126.14 79.21 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="89.17 126.14 93.09 126.14 93.09 144.47 89.17 144.47 89.17 126.14 89.17 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="99.14 126.14 103.06 126.14 103.06 144.47 99.14 144.47 99.14 126.14 99.14 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="109.11 126.14 113.03 126.14 113.03 144.47 109.11 144.47 109.11 126.14 109.11 126.14"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="119.07 125.93 122.99 125.93 122.99 144.59 119.07 144.59 119.07 125.93 119.07 125.93"
      />
      <polygon
        fill={resolveColor(svgColor)}
        fillRule="evenodd"
        points="129.04 125.93 132.96 125.93 132.96 144.59 129.04 144.59 129.04 125.93 129.04 125.93"
      />
    </g>
    <path
      fill={resolveColor(svgColor)}
      fillRule="evenodd"
      d="M102.46,0c.2-.02.4,0,.6,0h113.64c3.73.58,5.96,2.86,6.34,6.72v22.85c-.64,4.52-3.23,6.64-7.13,7.13h-77.13v46.14h70.19c4.15.43,6.75,2.62,7.22,7.26v22.32c-.59,4.54-3.14,6.71-7.17,7.11h-70.24v2.9l-43.84.3V7.73c.2-4.61,2.69-7.21,7.53-7.72Z"
    />
  </svg>
);

export const SupportSVG = ({
  className,
  backgroundColor = "white",
  accentColor = "#808285",
  svgColor = "#c43291",
}: {
  className?: string;
  backgroundColor?: string;
  accentColor?: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 134.31 114.36"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect
      fill={resolveColor(backgroundColor)}
      width="134.31"
      height="114.36"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M66.95,10.1c23.36,0,42.37,19.01,42.37,42.37s-19.01,42.37-42.37,42.37-42.37-19.01-42.37-42.37S43.59,10.1,66.95,10.1Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M134.31,53.83c0-9.19-5.51-16.93-13.05-19.4-1.78-.58-3.28-1.8-4.12-3.48C107.91,12.62,88.91,0,67.02,0S25.91,12.76,16.74,31.27c-.73,1.48-2,2.63-3.57,3.13C5.57,36.83,0,44.6,0,53.83c0,11.18,8.15,20.24,18.2,20.24h.03c1.86,0,3.36-1.51,3.36-3.37v-32.14c0-2.58.68-5.1,1.96-7.34,8.65-15.06,24.88-25.22,43.45-25.22s35.65,10.7,44.11,26.41c1.07,1.99,1.58,4.24,1.58,6.5v28.86c0,2.06-.39,4.11-1.21,6-6.12,13.99-18.44,24.56-33.35,28.45l-1.18-.31c-1.53-1.56-3.76-2.44-6.18-2.13-3.29.42-5.95,3.12-6.32,6.41-.5,4.42,2.95,8.17,7.27,8.17,3.41,0,6.26-2.33,7.08-5.48l.88-.84c16.48-4.31,30.14-15.91,37.07-31.3.74-1.64,2.17-2.82,3.9-3.31,7.85-2.25,13.65-10.17,13.65-19.6Z"
    />
  </svg>
);

export const SupportV2SVG = ({
  className,
  svgColor = "#c43291",
}: {
  className?: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    data-name="Layer 2"
    viewBox="0 0 32 27.23"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(svgColor)}
      d="M32,12.81c0-2.19-1.31-4.03-3.11-4.62-.42-.14-.78-.43-.98-.83C25.71,2.99,21.18-.02,15.97-.02S6.17,3.03,3.99,7.44c-.17.35-.48.63-.85.75-1.81.58-3.14,2.43-3.14,4.63,0,2.66,1.94,4.82,4.34,4.82h0c.44,0,.8-.36.8-.8v-7.66c0-.61.16-1.22.47-1.75C7.67,3.84,11.54,1.41,15.97,1.41s8.49,2.55,10.51,6.29c.26.47.38,1.01.38,1.55v6.88c0,.49-.09.98-.29,1.43-1.46,3.33-4.39,5.85-7.95,6.78l-.28-.07c-.36-.37-.89-.58-1.47-.51-.78.1-1.42.74-1.51,1.53-.12,1.05.7,1.95,1.73,1.95.81,0,1.49-.56,1.69-1.31l.21-.2c3.93-1.03,7.18-3.79,8.83-7.46.18-.39.52-.67.93-.79,1.87-.54,3.25-2.42,3.25-4.67Z"
    />
  </svg>
);

export const ContactUsSVG = ({
  className,
  backgroundColor = "white",
  accentColor = "#808285",
  svgColor = "#c43291",
}: {
  className?: string;
  backgroundColor?: string;
  accentColor?: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    data-name="Layer 2"
    viewBox="0 0 32.85 22.85"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="none"
      stroke={resolveColor(accentColor)}
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M26.25.8c-.11,0-.23,0-.34,0-7.33,0-14.67,0-22,0-.74,0-1.58.01-2.18.49s-.85,1.16-.91,1.92c-.02.24-.02.49-.02.74,0,4.05,0,8.09,0,12.14,0,.62,0,1.25.26,1.81.26.56.77.99,1.36,1.15.65.18,1.35.05,2.03.08s1.44.34,1.62,1c.11.39.03.81-.01,1.2-.03.3-.05.65.17.88s.58.24.86.15c.54-.18.98-.63,1.37-1.02.33-.33.65-.68.93-1.05.26-.34.49-.74.87-.95.34-.19.75-.19,1.14-.19,4.67,0,9.35.02,14.02.03.75,0,1.56-.01,2.18-.45.95-.67,1.04-2.02,1.04-3.18,0-3.69,0-7.38,0-11.07,0-.67,0-1.36-.2-2s-.62-1.25-1.25-1.51c-.3-.12-.63-.15-.95-.16Z"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="3.91"
      y="4.86"
      width="16.08"
      height="1.29"
      rx=".64"
      ry=".64"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="3.91"
      y="8.19"
      width="16.08"
      height="1.29"
      rx=".64"
      ry=".64"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="3.91"
      y="11.33"
      width="16.08"
      height="1.29"
      rx=".64"
      ry=".64"
    />
    <g>
      <circle fill={resolveColor(backgroundColor)} stroke={resolveColor(svgColor)} strokeWidth="1.5" strokeMiterlimit="10" cx="22.96" cy="12.62" r="9.11" />
      <path
        fill={resolveColor(svgColor)}
        d="M22.02,13.59c.21-.33.55-.67,1.02-1.02l1.23-.85c.54-.41.86-.89.97-1.45.11-.55.05-1.01-.17-1.38-.22-.36-.61-.6-1.15-.71s-.97-.05-1.35.17c-.38.22-.62.57-.71,1.04l-1.44-.29c.18-.85.61-1.47,1.3-1.87.69-.4,1.5-.5,2.45-.31s1.7.61,2.15,1.25c.44.64.57,1.42.39,2.34-.18.91-.78,1.71-1.79,2.43l-1.03.67c-.46.35-.77.92-.92,1.71l-1.45-.29c.13-.63.31-1.11.51-1.44ZM21.26,16.62c.22-.15.47-.2.73-.15s.47.19.62.42c.15.22.2.47.15.73s-.19.47-.42.62-.47.19-.73.14-.48-.19-.62-.41-.2-.47-.15-.73.19-.47.42-.62Z"
      />
    </g>
    <circle fill={resolveColor(accentColor)} cx="4.66" cy="15.29" r=".81" />
  </svg>
);

export const ContractSVG = ({
  className,
  accentColor = "#808285",
  svgColor = "#c43291",
}: {
  className?: string;
  accentColor?: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    data-name="Layer 2"
    viewBox="0 0 32 30.84"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <path
        fill={resolveColor(svgColor)}
        d="M1.53,16.03l2.95.02c1.03,0,1.98-.55,2.5-1.45.66-1.14,1.34-2.03,3.01-2.15.92-.07,1.89-.02,2.83-.03.4,0,.66.42.46.77l-2.7,4.64c-.85,1.45-.02,3.76,1.38,4.59s3.89.51,4.74-.97l1.3-2.24c.14-.24.45-.33.7-.18l6.27,3.65s.2.27.23.31c.14.26.16.62.06.9-.19.51-1.03,1.95-1.37,2.4-.38.51-1.01.55-1.54.32-.22-.1-.49-.03-.61.18-.49.81-.9,1.75-1.43,2.49-.58.82-1.58.71-2.36.27-.2-.11-.46-.08-.6.1-.89,1.12-2.5,1.56-3.82.92-1.83-.89-3.6-2.19-5.43-3.18-.4-.22-.86-.32-1.31-.32l-5.43-.03C.35,27.04,0,25.82,0,25.82v-8.11s.03-1.68,1.52-1.68Z"
      />
      <path
        fill={resolveColor(svgColor)}
        d="M30.85,26.13h-4.28c-.33,0-.53-.35-.37-.63.94-1.62.39-3.72-1.23-4.66l-6.47-3.76c-.45-.26-1.02-.11-1.28.34l-1.86,3.2c-.15.25-.82.6-1.11.67-1.62.36-2.9-1.3-2.2-2.79,1.16-1.73,2.09-3.85,3.23-5.56.38-.57,1.4-.83,1.91-.89.87-.1,2.26.17,2.75.4,1.38.66,2.71,1.66,4.09,2.39.34.18.72.26,1.11.27l5.67.06c1.38,0,1.19,1.38,1.19,1.38v8.1s0,1.48-1.15,1.48Z"
      />
    </g>
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M28.05,14.25c-.42,0-.75-.34-.75-.75V3.02c0-.83-.68-1.51-1.51-1.51H6.22c-.83,0-1.51.68-1.51,1.51v10.49c0,.42-.34.75-.75.75s-.75-.34-.75-.75V3.02c0-1.66,1.35-3.02,3.02-3.02h19.56c1.66,0,3.02,1.35,3.02,3.02v10.49c0,.42-.34.75-.75.75Z"
      />
      <g>
        <rect
          fill={resolveColor(accentColor)}
          x="8.61"
          y="5.19"
          width="14.77"
          height="1.24"
          rx=".62"
          ry=".62"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="8.61"
          y="8.96"
          width="14.77"
          height="1.24"
          rx=".62"
          ry=".62"
        />
      </g>
    </g>
  </svg>
);

export const SignoutSVG = ({
  className,
  accentColor = "#808285",
  svgColor = "#c43291",
}: {
  className?: string;
  accentColor?: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 130.45 172.26"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill={resolveColor(accentColor)}
        d="M52.4,148.14c0,4.38-3.55,7.94-7.94,7.94h-16.74c-4.38,0-7.94-3.55-7.94-7.94V24.12c0-4.38,3.55-7.94,7.94-7.94h16.47c4.38,0,7.94,3.55,7.94,7.94v1.97c0,.98.79,1.77,1.77,1.77h12.35c.98,0,1.77-.79,1.77-1.77V8.35c.17-.07.26-.11.26-.11,0-4.38-3.55-7.94-7.94-7.94h-.25s0,0,0,0H8.41s0,0,0,0h-.25C3.76.3.21,3.86.21,8.24v155.78l.26-.22v.22c0,4.38,3.55,7.94,7.94,7.94h51.92c4.38,0,7.94-3.55,7.94-7.94v-17.85c0-.98-.79-1.77-1.77-1.77h-12.35c-.98,0-1.77.79-1.77,1.77v1.97Z"
      />
      <path
        fill={resolveColor(svgColor)}
        d="M128.86,82.66l-36.95-38.94c-3.13-3.3-8.69-1.08-8.69,3.47v17.3c0,2.78-2.26,5.04-5.04,5.04h-24.26c-2.78,0-5.04,2.26-5.04,5.04v23.11c0,2.78,2.26,5.04,5.04,5.04h24.26c2.78,0,5.04,2.26,5.04,5.04v17.3c0,4.55,5.56,6.77,8.69,3.47l36.95-38.94c1.85-1.94,1.85-4.99,0-6.94Z"
      />
    </svg>
  );
};

export const HeartSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 12.54 11.96"
      className={className}
    >
      <path
        fill={resolveColor(svgColor)}
        d="M12.52,3.19c-.1-.99-.54-1.8-1.32-2.42C10.45,.16,9.58-.08,8.62,.03c-.85,.1-1.56,.46-2.15,1.08-.06,.06-.12,.13-.18,.2,0,0,0,0,0,0,0,0,0,0,0,0-.06-.07-.12-.14-.18-.2C5.49,.49,4.77,.12,3.93,.03c-.96-.11-1.83,.14-2.59,.74C.56,1.39,.12,2.2,.02,3.19c-.08,.77,.1,1.5,.39,2.21,.42,1.02,1.05,1.92,1.75,2.75,1.16,1.38,2.5,2.58,3.94,3.68,.06,.04,.12,.09,.17,.13,0,0,0,0,0,0,0,0,0,0,0,0,.06-.04,.11-.08,.17-.13,1.43-1.1,2.77-2.3,3.94-3.68,.71-.84,1.33-1.73,1.75-2.75,.29-.71,.47-1.44,.39-2.21Z"
      />
    </svg>
  );
};

export const CategorySVG = ({
  className,
  svgColor = "pinkCustom",
  bgColor,
}: {
  className: string;
  svgColor?: string;
  bgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 162.5 159.47"
    className={className}
    style={bgColor ? { backgroundColor: resolveColor(bgColor) } : undefined}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(svgColor)}
      d="M71.98,38.89v24.56c0,5.67-2.76,8.38-8.46,8.35-16.34-.08-32.74.16-49.09-.16-8.78-.19-14.23-4.91-14.37-14.04-.24-14.39-.38-28.81.03-43.18C.39,4.6,5.02.4,15.08.18,28.5-.09,41.91-.09,55.33.18c11.57.22,16.32,5.23,16.64,17.13.19,7.18.03,14.39.03,21.6h-.03v-.03Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M122.69,71.8c-7.51,0-15.07-.16-22.58.03-6.53.19-9.73-2.52-9.65-9.24.14-15.72-.19-31.42.19-47.14.24-10.03,5.37-15.02,15.42-15.26,14.07-.33,28.14-.19,42.23-.03,9.08.11,14.04,5.1,14.2,14.07.24,14.39.24,28.79,0,43.18-.14,9.11-5.45,13.82-14.26,14.18-8.51.35-17,.08-25.54.08v.11h0l-.03.03Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M71.93,120.82c0,7.5.24,15.06-.05,22.53-.41,10.81-5.09,15.68-15.65,15.92-13.7.3-27.46.3-41.16,0-10.45-.22-14.76-4.5-15.03-15.14-.32-13.7-.32-27.46,0-41.16.24-9.72,4.87-14.65,14.54-14.92,16.33-.46,32.66-.16,49.02-.19,5.66,0,8.39,2.76,8.37,8.45-.03,8.15,0,16.33,0,24.51h-.03Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M90.55,120.76c0-8.15.03-16.33,0-24.51-.03-5.66,2.73-8.42,8.39-8.39,16.33.03,32.68-.27,49.01.19,9.64.27,14.24,5.2,14.49,14.95.35,13.7.35,27.46,0,41.16-.27,10.64-4.58,14.92-15.06,15.11-13.7.27-27.46.27-41.16,0-10.56-.24-15.22-5.09-15.62-15.95-.27-7.5-.05-15.03-.05-22.53h0v-.03Z"
    />
  </svg>
);

export const SettingSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className}
    >
      <g id="setting">
        <path
          fill={resolveColor(svgColor)}
          d="m27.92 18.46-1.14-.92a.86.86 0 0 1-.31-.65V15.2a.83.83 0 0 1 .31-.65l1.11-.89a2.86 2.86 0 0 0 .65-3.66l-1.12-1.88a2.76 2.76 0 0 0-3.21-1.22l-1.82.58a.73.73 0 0 1-.64-.09l-1.23-.81a.8.8 0 0 1-.36-.58l-.24-1.6A2.77 2.77 0 0 0 17.18 2h-2.25a2.79 2.79 0 0 0-2.77 2.51L12 6a.8.8 0 0 1-.41.63L10 7.48a.79.79 0 0 1-.67 0L8.08 7a2.75 2.75 0 0 0-3.46 1.1L3.48 10a2.84 2.84 0 0 0 .57 3.64l1.35 1.11a.87.87 0 0 1 .29.62v1.27a.87.87 0 0 1-.28.65L4 18.61a2.85 2.85 0 0 0-.57 3.52l1 1.84a2.77 2.77 0 0 0 3.42 1.22l1.62-.63a.73.73 0 0 1 .66.05l1.4.84a.76.76 0 0 1 .38.55l.32 1.66A2.81 2.81 0 0 0 15 29.94h2.15a2.79 2.79 0 0 0 2.75-2.39l.26-1.65a.85.85 0 0 1 .4-.6l1.3-.74a.78.78 0 0 1 .65 0l1.64.63a2.76 2.76 0 0 0 3.37-1.2l1.08-1.83a2.86 2.86 0 0 0-.68-3.7zm-1.07 2.64-1.08 1.83a.78.78 0 0 1-.94.34l-1.64-.63a2.77 2.77 0 0 0-2.35.19l-1.3.74a2.81 2.81 0 0 0-1.39 2l-.26 1.66a.78.78 0 0 1-.77.69H15a.79.79 0 0 1-.77-.66l-.32-1.66a2.81 2.81 0 0 0-1.33-1.89l-1.4-.84a2.73 2.73 0 0 0-1.41-.39 2.91 2.91 0 0 0-1 .19l-1.62.64a.77.77 0 0 1-1-.35l-1-1.84a.84.84 0 0 1 .16-1l1.48-1.32a2.87 2.87 0 0 0 .94-2.17v-1.27a2.9 2.9 0 0 0-1-2.11l-1.37-1.17A.85.85 0 0 1 5.19 11l1.14-1.86a.76.76 0 0 1 1-.32l1.25.53A2.72 2.72 0 0 0 11 9.23l1.61-.89A2.81 2.81 0 0 0 14 6.17l.16-1.46a.79.79 0 0 1 .77-.71h2.24a.79.79 0 0 1 .78.7l.23 1.61a2.85 2.85 0 0 0 1.24 2l1.23.8a2.72 2.72 0 0 0 2.35.27l1.82-.57a.76.76 0 0 1 .89.34L26.83 11a.86.86 0 0 1-.19 1.09l-1.11.91a2.84 2.84 0 0 0-1.06 2.22v1.69a2.81 2.81 0 0 0 1.05 2.2l1.14.92a.86.86 0 0 1 .19 1.07z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M16 11a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3.07z"
        />
      </g>
    </svg>
  );
};

export const EditSVG = ({ className, svgColor = "pinkCustom", accentColor = "pinkCustom" }: { className: string, svgColor?: string, accentColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 189.45 195.61"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M184.48,185.48H61.73c-2.8,0-5.07,2.27-5.07,5.07s2.27,5.07,5.07,5.07h122.75c2.8,0,5.07-2.27,5.07-5.07s-2.27-5.07-5.07-5.07Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M144.03,24.45L111.52,2.14c-3.2-2.2-7.58-1.38-9.78,1.82l-9.29,13.54c-2.2,3.2-1.38,7.58,1.82,9.78l32.51,22.31c3.2,2.2,7.58,1.38,9.78-1.82l9.29-13.53c2.2-3.2,1.38-7.58-1.82-9.78Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M123.05,57.14l-34.49-23.67c-2.65-1.82-6.28-1.15-8.1,1.51L4.96,144.97c-.62.9-.99,1.94-1.09,3.02L.29,188.94c-.43,4.88,4.61,8.36,9.02,6.25l37.29-17.85c1-.48,1.85-1.21,2.48-2.12l75.48-109.97c1.82-2.65,1.15-6.28-1.51-8.1Z"
    />
  </svg>
);
export const PreviewSVG = ({
  className,
  svgColor,
  primaryColor,
  accentColor,
}: {
  className: string;
  svgColor?: string;
  primaryColor?: string;
  accentColor?: string;
}) => {
  const baseFill = resolveColor(primaryColor ?? svgColor ?? "grayCustom");
  const accentFill = resolveColor(accentColor ?? svgColor ?? "pinkCustom");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 220.65 221.54"
      className={className}
    >
      <path
        fill={accentFill}
        d="M220.13,38.28c-1.44-19.83-16.95-35.71-37.11-37.76l-146.31.08-.23.02C16.59,2.8,1.25,18.85,0,38.89v143.83c1.51,20.25,17.99,36.52,38.35,37.83,5.4.36,10.93.48,16.5.48,6.99,0,14.05-.19,20.96-.39,11.4-.33,23.2-.65,34.68-.09,5.81-.41,8.87-4.67,9.33-8.7.45-4.05-1.59-8.88-7.19-10.58l-73.82-.35c-10.71-1.28-18.43-9.3-19.22-19.79V40c.73-10.48,8.61-18.69,18.91-19.97l142.48-.03c10.77,1.05,18.83,9.28,19.58,20,.83,11.77.45,24.29.08,36.4-.34,11.39-.7,23.16-.02,34.76,1.31,5.7,5.79,8.09,9.94,8.05,3.99-.11,8.5-2.8,9.55-9.06-.62-11.12-.24-22.87.1-34.23.39-12.5.79-25.42-.08-37.64Z"
      />
      <path
        fill={baseFill}
        d="M175.33,124.47c-15.09,1.4-27.93,11.13-33.54,25.38-5.35,13.59-3.03,28.68,6,39.85l-15.21,15.9-.36.49c-2.11,4.1-1.33,8.75,2.01,11.83,1.87,1.72,4.14,2.62,6.54,2.62,1.95,0,3.97-.6,5.92-1.83l16.69-16.5c14.18,6.03,30.12,3.81,41.93-5.94,12.21-10.05,17.39-25.93,13.53-41.45-4.83-19.48-23.11-32.15-43.5-30.34ZM200.52,164.95c0,11.61-9.44,21.05-21.05,21.05s-21.04-9.44-21.04-21.05,9.44-21.05,21.04-21.05,21.05,9.44,21.05,21.05Z"
      />
      <path
        fill={accentFill}
        d="M63.07,89.44l94.29-.02c6.03-.84,8.78-5.65,8.78-9.76s-2.74-8.92-9.07-9.79l-94.84.11-.5.06c-5.64,1.42-7.93,6.12-7.7,10.16.21,4.02,3.02,8.43,9.05,9.24Z"
      />
      <path
        fill={accentFill}
        d="M118.95,131.59l-56.72.07-.5.06c-5.48,1.37-7.83,5.94-7.72,9.88.1,3.92,2.69,8.36,8.63,9.47l56.72-.04c5.68-1.12,8.22-5.68,8.22-9.7s-2.55-8.59-8.63-9.75Z"
      />
    </svg>
  );
};

export const StarSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 40.64 38.89"
      className={className}
    >
      <path
        fill={resolveColor(svgColor)}
        d="M39.26,13.57l-4.65-.83c-4.52-.81-8.42-3.64-10.59-7.69l-2.23-4.17c-.63-1.18-2.32-1.18-2.95,0l-2.23,4.17c-2.16,4.05-6.06,6.88-10.59,7.69l-4.65.83c-1.31.23-1.84,1.84-.91,2.8l3.28,3.41c3.18,3.31,4.67,7.9,4.04,12.44l-.65,4.68c-.18,1.32,1.18,2.32,2.38,1.73l4.25-2.06c4.13-2.01,8.95-2.01,13.08,0l4.25,2.06c1.2.58,2.57-.41,2.38-1.73l-.65-4.68c-.63-4.55.86-9.13,4.04-12.44l3.28-3.41c.93-.96.4-2.57-.91-2.8Z"
      />
    </svg>
  );
};

export const ControlPanelSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 32 32"
      className={className}
    >
      <g>
        <path
          fill={resolveColor(accentColor)}
          d="M2.9,9.83h26.2c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06H2.9C1.22,3.71-.16,5.09-.16,6.77s1.37,3.06,3.06,3.06ZM29.1,8.33H2.9c-.86,0-1.56-.7-1.56-1.56s.7-1.56,1.56-1.56h26.2c.86,0,1.56.7,1.56,1.56s-.7,1.56-1.56,1.56Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M29.1,12.98H2.9c-1.69,0-3.06,1.37-3.06,3.06s1.37,3.06,3.06,3.06h26.2c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06ZM29.1,17.6H2.9c-.86,0-1.56-.7-1.56-1.56s.7-1.56,1.56-1.56h26.2c.86,0,1.56.7,1.56,1.56s-.7,1.56-1.56,1.56Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M29.1,22.25H2.9c-1.69,0-3.06,1.37-3.06,3.06s1.37,3.06,3.06,3.06h26.2c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06ZM29.1,26.86H2.9c-.86,0-1.56-.7-1.56-1.56s.7-1.56,1.56-1.56h26.2c.86,0,1.56.7,1.56,1.56s-.7,1.56-1.56,1.56Z"
        />
      </g>
      <circle fill={resolveColor(svgColor)} cx="13.9" cy="6.77" r="3.87" />
      <circle fill={resolveColor(svgColor)} cx="22.6" cy="16.04" r="3.87" />
      <circle fill={resolveColor(svgColor)} cx="7.24" cy="25.23" r="3.87" />
    </svg>
  );
};

export const MediaExplorerSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
  bgColor = "white",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
  bgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      data-name="Layer 2"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill={resolveColor(accentColor)}
        d="M28.33,8.46h-11.18c-.53,0-.96-.43-.96-.96h0c0-1.02-.82-1.84-1.84-1.84H3.17c-1.02,0-1.84.82-1.84,1.84v18.66c0,1.5,1.22,2.72,2.72,2.72h24.28c1.5,0,2.72-1.22,2.72-2.72v-14.98c0-1.5-1.22-2.72-2.72-2.72Z"
      />
      <g>
        <rect
          fill={resolveColor(bgColor)}
          stroke={resolveColor(accentColor)}
          strokeMiterlimit="10"
          strokeWidth=".79px"
          x="4.7"
          y="3.58"
          width="22.98"
          height="19.62"
          rx="1.16"
          ry="1.16"
          transform="translate(-.96 25.53) rotate(-74.88)"
        />
        <rect
          fill={resolveColor(bgColor)}
          stroke={resolveColor(accentColor)}
          strokeMiterlimit="10"
          strokeWidth=".79px"
          x="5.53"
          y="0"
          width="19.62"
          height="22.98"
          rx="1.16"
          ry="1.16"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="8.02"
          y="2.88"
          width="14.47"
          height=".71"
          rx=".35"
          ry=".35"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="8.02"
          y="5.83"
          width="14.47"
          height=".71"
          rx=".35"
          ry=".35"
        />
      </g>
      <path
        fill={resolveColor(svgColor)}
        d="M28.33,11.58h-11.18c-.53,0-.96-.43-.96-.96h0c0-1.02-.82-1.84-1.84-1.84H3.17c-1.02,0-1.84.82-1.84,1.84v18.66c0,1.5,1.22,2.72,2.72,2.72h24.28c1.5,0,2.72-1.22,2.72-2.72v-14.98c0-1.5-1.22-2.72-2.72-2.72Z"
      />
    </svg>
  );
};

export const CallSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.49 81.29" className={className}>
    <path fill={resolveColor(svgColor)} d="M75.13,55.26l-13.4-4.59c-1.34-.46-2.99-.62-5.26,1.63-.49.48-.93,1.02-1.38,1.59-.73,1.04-2.9,4.25-2.9,4.25l-1.35,1.99-2.1-1.16c-5.44-3.03-10.5-6.86-15.02-11.41-4.53-4.52-8.38-9.59-11.42-15.02l-1.16-2.11,1.99-1.34s3.21-2.17,4.22-2.87c.61-.48,1.16-.95,1.63-1.41,2.26-2.27,2.08-3.92,1.62-5.29l-4.57-13.37C24.42,1.41,19.2-1.14,14.47.49l-4.83,1.63c-2.06.73-3.89,1.86-5.42,3.39-.98.97-1.81,2.09-2.45,3.28-.82,1.5-1.35,3.1-1.59,4.72-.24,1.44-.24,2.88.01,4.28l.18.73c3.45,14.78,11.59,29.37,22.3,40.1,10.72,10.71,25.33,18.85,40.11,22.3l.73.16c1.4.25,2.84.27,4.31.03,1.59-.24,3.19-.77,4.67-1.6,1.23-.62,2.33-1.46,3.31-2.44,1.53-1.53,2.66-3.37,3.37-5.45l1.65-4.81c1.63-4.72-.92-9.94-5.67-11.56Z" />
  </svg>
);

export const EmailSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.46 97.63" className={className}>
    <path fill={resolveColor(accentColor)} d="M1.8,88.09C.66,86.21,0,84,0,81.65V14.88c0-.23,0-.47.02-.7l40.38,35.31L1.8,88.09Z" />
    <path fill={resolveColor(accentColor)} d="M130.79,14.18c.01.23.02.46.02.7v66.77c0,2.36-.66,4.56-1.8,6.44l-38.61-38.6,40.38-35.31Z" />
    <path fill={resolveColor(svgColor)} d="M70.68,53.05c-1.45,1.27-3.42,1.96-5.54,1.96s-4.09-.7-5.54-1.96L5.3,5.59C7.54,2.21,11.37-.02,15.71-.02h98.85c4.34,0,8.17,2.23,10.41,5.61l-54.29,47.46Z" />
    <path fill={resolveColor(accentColor)} d="M48.16,56.94l7.49,6.55c2.53,2.21,5.9,3.43,9.48,3.43s6.95-1.22,9.48-3.43l7.49-6.55,38.89,38.89c-1.88,1.14-4.09,1.8-6.44,1.8H15.71c-2.36,0-4.56-.66-6.44-1.8l38.89-38.89Z" />
  </svg>
);

export const FavSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.46 121.84" className={className}>
    <path fill={resolveColor(svgColor)} fillRule="evenodd" d="M107.57.64c-22.41-3.11-27.49,7.69-40.33,17.19-1.2.89-2.84.89-4.04,0C50.35,8.32,42.8-2.8,22.86.64-1.03,4.75-6.08,42.13,7.17,70.15c10.5,22.19,25.8,39.76,47.4,49.43,6.73,3.01,14.46,3.04,21.14-.08,20.15-9.42,37.15-27.4,47.53-49.35,13.26-28.02,8.33-66.18-15.68-69.51Z" />
  </svg>
);

export const HSLogoSVG = ({
  className,
  svgColor = "#86868b",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.87 172.23" className={className}>
    <path fill={resolveColor(svgColor)} fillRule="evenodd" d="M64.56,42.33h25.12v31.16h19.51v-31.16h25.13v87.5h-25.13v-31.16h-19.51v31.16h-25.12V42.33h0ZM189.96,72.15h-46.35v27.74h15.79l-26.09,44.77h-67.78l-20.58-35.48H13.34l36.4,63.05h99.43l49.7-86.15-8.92-13.93h0ZM185.42,62.81L149.13,0H49.7L0,86.08l7.99,13.82h47.37v-27.74s-15.79,0-15.79,0l25.99-44.76h67.72l20.48,35.42h31.66Z" />
  </svg>
);

export const LocationSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.17 121.84" className={className}>
    <path fill={resolveColor(svgColor)} d="M40.14,106.24c9.04-11.74,17.26-23.91,24.1-36.96,4.79-9.13,8.88-18.52,10.54-28.82C78.21,19.24,61.19-.23,39.66,0,18.55.23-.48,20.07,6.36,45.75c3.34,12.53,9.12,23.97,16.01,34.83,5.27,8.32,11.08,16.31,16.66,24.43.28.41.68.75,1.12,1.23ZM22.42,35.1c0-9.84,7.81-17.64,17.64-17.64,9.77,0,17.7,7.89,17.74,17.64.03,9.82-8.11,17.95-17.86,17.83-9.84-.13-17.53-7.95-17.52-17.83Z" />
    <path fill={resolveColor(accentColor)} d="M56.36,99.34c5.23,1.4,10.24,2.21,14.67,6.09-1.9,1.1-3.44,2.24-5.16,2.94-7.43,3.05-15.27,3.91-23.21,4.11-8.8.23-17.52-.4-25.94-3.18-2.52-.83-4.85-2.21-7.74-3.57,4.4-4.25,9.51-4.93,14.74-6.39-1.7-2.59-3.29-5.13-5.03-7.56-.25-.35-1.29-.44-1.8-.23-3.83,1.56-7.92,2.77-11.37,4.96-7.42,4.72-7.28,12.65-.01,17.67,5.16,3.56,11.08,5.12,17.15,6.12,14.26,2.34,28.48,2.24,42.44-1.84,3.6-1.05,7.19-2.77,10.26-4.92,6.35-4.43,6.47-12.05.11-16.37-3.71-2.52-8.22-3.87-12.42-5.65-.45-.19-1.44.06-1.71.44-1.68,2.33-3.22,4.75-4.96,7.38Z" />
  </svg>
);

export const PlacementSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174.66 147.16" className={className}>
    <path fill={resolveColor(svgColor)} d="M170.85,83.56H25.7c-2.14,0-3.87,1.71-3.87,3.81v55.55c0,2.11,1.73,3.81,3.87,3.81h145.15c2.14,0,3.87-1.71,3.87-3.81v-55.55c0-2.11-1.73-3.81-3.87-3.81Z" />
    <g fill={resolveColor(accentColor)}>
      <rect x="21.83" y="52.13" width="2.69" height="6.89" />
      <rect x="50.64" y=".43" width="7" height="2.65" />
      <rect x="40.97" y="62.5" width="7" height="2.65" />
      <rect x="64.64" y=".43" width="7" height="2.65" />
      <rect x="82.95" y="62.5" width="7" height="2.65" />
      <rect x="92.63" y=".43" width="7" height="2.65" />
      <rect x="68.95" y="62.5" width="7" height="2.65" />
      <rect x="54.96" y="62.5" width="7" height="2.65" />
      <rect x="21.83" y="24.55" width="2.69" height="6.89" />
      <rect x="21.83" y="10.76" width="2.69" height="6.89" />
      <rect x="21.83" y="38.34" width="2.69" height="6.89" />
      <path d="M29.65,3.07V.43h-2.68c-1.99,0-3.82,1.15-4.66,2.93l2.44,1.12c.4-.85,1.28-1.4,2.23-1.4h2.68Z" />
      <rect x="36.65" y=".43" width="7" height="2.65" />
      <polygon points="26.93 62.75 26.97 65.14 33.97 65.14 33.97 62.5 26.93 62.5 26.93 62.75" />
      <rect x="78.63" y=".43" width="7" height="2.65" />
      <path d="M169.57,62.5h-2.66v2.65h2.66c2.01,0,3.84-1.16,4.68-2.95l-2.44-1.1c-.4.86-1.28,1.41-2.24,1.41Z" />
      <rect x="152.92" y="62.5" width="7" height="2.65" />
      <rect x="172.03" y="47.9" width="2.69" height="6.89" />
      <polygon points="169.57 .43 162.6 .43 162.6 3.07 169.6 3.07 169.57 .43" />
      <rect x="172.03" y="6.53" width="2.69" height="6.9" />
      <rect x="172.03" y="20.32" width="2.69" height="6.89" />
      <rect x="172.03" y="34.11" width="2.69" height="6.9" />
      <rect x="134.61" y=".43" width="7" height="2.65" />
      <rect x="110.94" y="62.5" width="7" height="2.65" />
      <rect x="148.6" y=".43" width="7" height="2.65" />
      <rect x="106.62" y=".43" width="7" height="2.65" />
      <rect x="120.62" y=".43" width="7" height="2.65" />
      <rect x="124.93" y="62.5" width="7" height="2.65" />
      <rect x="138.93" y="62.5" width="7" height="2.65" />
      <rect x="96.94" y="62.5" width="7" height="2.65" />
    </g>
    <path fill={resolveColor(svgColor)} d="M16.21,51.4c.47-.33.58-.97.24-1.43-.33-.46-.98-.57-1.45-.24-.36.26-8.93,6.39-10.86,17.89-1.42,8.46,1.16,17.48,7.64,26.85l-3.37-.59,1.72,2.43,4.92.86.88-4.85-1.72-2.43-.64,3.53c-6.21-8.94-8.71-17.49-7.39-25.43,1.77-10.65,9.94-16.52,10.02-16.58Z" />
  </svg>
);

export const WebSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.49 81.29" className={className}>
    <path fill={resolveColor(svgColor)} d="M2.86,24.91C7.56,13.22,17.66,4.28,30.06,1.18c-3.89,5.17-6.82,13.5-8.26,23.72H2.86Z" />
    <path fill={resolveColor(svgColor)} d="M78.63,56.39c-4.7,11.68-14.8,20.62-27.2,23.72,3.89-5.17,6.82-13.5,8.26-23.72h18.93Z" />
    <path fill={resolveColor(svgColor)} d="M40.65,81.29c-5.21,0-10.87-9.72-13.18-24.9h26.37c-2.31,15.19-7.98,24.9-13.18,24.9Z" />
    <path fill={resolveColor(svgColor)} d="M20.79,40.65c0,3.52.16,6.9.46,10.15H1.32c-.86-3.24-1.32-6.64-1.32-10.15s.46-6.9,1.32-10.14h19.93c-.3,3.24-.46,6.63-.46,10.14Z" />
    <path fill={resolveColor(svgColor)} d="M51.43,1.18c12.4,3.1,22.49,12.04,27.2,23.72h-18.93c-1.44-10.22-4.38-18.55-8.26-23.72Z" />
    <path fill={resolveColor(svgColor)} d="M40.65,0C45.85,0,51.52,9.72,53.83,24.91h-26.37C29.78,9.72,35.44,0,40.65,0Z" />
    <path fill={resolveColor(svgColor)} d="M30.06,80.11c-12.4-3.1-22.49-12.04-27.2-23.72h18.93c1.44,10.22,4.38,18.55,8.26,23.72Z" />
    <path fill={resolveColor(svgColor)} d="M60.7,40.65c0-3.51-.16-6.9-.46-10.14h19.94c.86,3.24,1.32,6.64,1.32,10.14s-.46,6.9-1.32,10.15h-19.94c.3-3.24.46-6.63.46-10.15Z" />
    <path fill={resolveColor(svgColor)} d="M54.91,40.65c0,3.56-.18,6.95-.5,10.15h-27.53c-.32-3.2-.49-6.59-.49-10.15s.18-6.95.49-10.14h27.53c.32,3.2.5,6.59.5,10.14Z" />
  </svg>
);

export const ZipcodeSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 81.49 81.29"
    className={className}
  >
    <path
      fill={resolveColor(accentColor)}
      d="M25.91,57.71h46.23c4.38,0,7.94-3.55,7.94-7.94v-31.42c0-4.38-3.55-7.94-7.94-7.94H25.91"
    />

    <g>
      <path
        fill="#fff"
        d="M36.57,56.84c1.88,0,3.41-1.47,3.41-3.29v-28.73c0-7.49-6.3-13.56-14.07-13.56h0c-7.77,0-14.07,6.07-14.07,13.56v28.45c0,2.04,1.66,3.69,3.7,3.68l21.03-.12Z"
      />
      <path
        fill="none"
        stroke={resolveColor(accentColor)}
        strokeMiterlimit="10"
        strokeWidth="1.68"
        d="M36.57,56.84c1.88,0,3.41-1.47,3.41-3.29v-28.73c0-7.49-6.3-13.56-14.07-13.56h0c-7.77,0-14.07,6.07-14.07,13.56v28.45c0,2.04,1.66,3.69,3.7,3.68l21.03-.12Z"
      />
    </g>

    <g>
      <g>
        <path
          fill={resolveColor(svgColor)}
          d="M36.92,25.59H2.93c-1.62,0-2.93,1.34-2.93,2.99v19.07c0,1.65,1.31,2.99,2.93,2.99h33.98"
        />
        <path
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.43"
          d="M36.92,25.59H2.93c-1.62,0-2.93,1.34-2.93,2.99v19.07c0,1.65,1.31,2.99,2.93,2.99h33.98"
        />
      </g>

      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="1.52"
        d="M36.4,25.59l-8.07,7.52-9.12,7.71c-.34.29-.86.29-1.2,0l-9.12-7.71L.82,26.26"
      />
    </g>

    <path
      fill={resolveColor(accentColor)}
      d="M47.02,59.69v9.94c0,1.65,1.34,2.99,2.99,2.99h5.97c1.65,0,2.99-1.34,2.99-2.99v-9.94"
    />

    <circle fill="#fff" cx="62.38" cy="27.28" r="6.03" />
  </svg>
);

export const DocumentsPanelSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
  bgColor = "white",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
  bgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      data-name="Layer 2"
      viewBox="0 0 32 32"
      className={className}
    >
      <g>
        <g>
          <rect
            fill={resolveColor(bgColor)}
            stroke={resolveColor(accentColor)}
            strokeMiterlimit="10"
            strokeWidth="1.47px"
            x="11.74"
            y="7.14"
            width="16.96"
            height="19.87"
            rx="1"
            ry="1"
            transform="translate(9.23 -7) rotate(25.28)"
          />
          <rect
            fill={resolveColor(bgColor)}
            stroke={resolveColor(accentColor)}
            strokeMiterlimit="10"
            strokeWidth="1.47px"
            x="7.96"
            y="5.54"
            width="18.25"
            height="21.38"
            rx="1.08"
            ry="1.08"
            transform="translate(4.83 -3.9) rotate(15.12)"
          />
        </g>
        <rect
          fill={resolveColor(bgColor)}
          stroke={resolveColor(svgColor)}
          strokeMiterlimit="10"
          strokeWidth="1.47px"
          x=".71"
          y="3.66"
          width="20.75"
          height="24.3"
          rx="1.23"
          ry="1.23"
        />
        <g fill={resolveColor(svgColor)}>
          <rect x="7.24" y="12.22" width="11.03" height=".82" rx=".33" ry=".33" />
          <rect x="7.24" y="15.63" width="11.03" height=".82" rx=".33" ry=".33" />
          <rect x="7.24" y="19.04" width="11.03" height=".82" rx=".33" ry=".33" />
        </g>
      </g>
      <g fill={resolveColor(accentColor)}>
        <circle cx="5.26" cy="12.88" r=".81" />
        <circle cx="5.26" cy="16.24" r=".81" />
        <circle cx="5.26" cy="19.7" r=".81" />
      </g>
    </svg>
  );
};

export const PropertiesSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "var(--color-gray-500)",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 32 32"
    className={className}
  >
    <rect
      fill={resolveColor(svgColor)}
      x="7.29"
      y="9.94"
      width="24.71"
      height="4.24"
      rx=".55"
      ry=".55"
    />
    <rect
      fill={resolveColor(accentColor)}
      y="9.94"
      width="4.14"
      height="4.24"
      rx=".46"
      ry=".46"
    />
    <rect
      fill={resolveColor(svgColor)}
      x="7.29"
      y="17.82"
      width="24.71"
      height="4.24"
      rx=".55"
      ry=".55"
    />
    <rect
      fill={resolveColor(accentColor)}
      y="17.82"
      width="4.14"
      height="4.24"
      rx=".46"
      ry=".46"
    />
  </svg>
);

export const ListSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      width="17.78"
      height="10.48"
      viewBox="0 0 17.78 10.48"
      className={className}
    >
      <rect
        fill={resolveColor(svgColor)}
        width="3.52"
        height="3.52"
        rx=".37"
        ry=".37"
      />
      <rect
        fill={resolveColor(svgColor)}
        x="6.49"
        width="11.29"
        height="3.52"
        rx=".37"
        ry=".37"
      />
      <rect
        fill={resolveColor(svgColor)}
        y="6.96"
        width="3.52"
        height="3.52"
        rx=".37"
        ry=".37"
      />
      <rect
        fill={resolveColor(svgColor)}
        x="6.49"
        y="6.96"
        width="11.29"
        height="3.52"
        rx=".37"
        ry=".37"
      />
    </svg>
  );
};

export const SaveSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      version="1.1"
      id="Capa_1"
      width="800px"
      height="800px"
      viewBox="0 0 407.096 407.096"
      className={className}
    >
      <g fill={resolveColor(svgColor)}>
        <g>
          <path d="M402.115,84.008L323.088,4.981C319.899,1.792,315.574,0,311.063,0H17.005C7.613,0,0,7.614,0,17.005v373.086    c0,9.392,7.613,17.005,17.005,17.005h373.086c9.392,0,17.005-7.613,17.005-17.005V96.032    C407.096,91.523,405.305,87.197,402.115,84.008z M300.664,163.567H67.129V38.862h233.535V163.567z" />
          <path d="M214.051,148.16h43.08c3.131,0,5.668-2.538,5.668-5.669V59.584c0-3.13-2.537-5.668-5.668-5.668h-43.08    c-3.131,0-5.668,2.538-5.668,5.668v82.907C208.383,145.622,210.92,148.16,214.051,148.16z" />
        </g>
      </g>
    </svg>
  );
};

export const PublishSVG = ({
  className,
  svgColor = "slateCustom",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 455 455"
      className={className}
    >
      <g fill={resolveColor(svgColor)}>
        <rect x="77.5" y="7.5" width="300" height="62.5" />
        <path d="M92.5,447.5h270V255h-270V447.5z M127.5,295h200v30h-200V295z M127.5,365h200v30h-200V365z" />
        <path d="M0,100v280h62.5V225h330v155H455V100H0z M377.5,175c-8.284,0-15-6.716-15-15c0-8.284,6.716-15,15-15s15,6.716,15,15   C392.5,168.284,385.784,175,377.5,175z" />
      </g>
    </svg>
  );
};

export const SolutionSVG = ({ className, svgColor = "pinkCustom", accentColor = "var(--color-gray-500)" }: { className: string, svgColor?: string, accentColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 171.86 172.26"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M87.65,53.06c-.68-1.2-1.69-2.22-2.89-2.9-3.1-1.79-6.22-2.08-8.92-1.34-1.61.44-3.21-.71-3.21-2.38,0-4.22.06-13.32.1-18.63.02-2.26-1.81-4.09-4.07-4.09H15.57c-7.58,0-13.72,6.14-13.72,13.72v54.78c0,1.27,1.03,2.29,2.29,2.29h13.27c3.45,0,6.22-2.66,6.58-6.09.45-4.33,5.05-9.38,13.74-9.38,9.3,0,13.71,6.41,13.72,11.07,0,2.45,2.1,4.39,4.55,4.39h14.35c1.27,0,2.29-1.03,2.29-2.29v-22.32c0-.83.85-1.41,1.6-1.07,1.35.62,2.84.96,4.42.96,7.83,0,13.7-8.44,8.99-16.72Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M31.2,86.1c-1.2.68-2.22,1.69-2.9,2.89-1.79,3.1-2.08,6.22-1.34,8.92.44,1.61-.71,3.21-2.38,3.21-4.22,0-13.32-.06-18.63-.1-2.26-.02-4.09,1.81-4.09,4.07v53.1c0,7.58,6.14,13.72,13.72,13.72h54.78c1.27,0,2.29-1.03,2.29-2.29v-13.27c0-3.45-2.66-6.22-6.09-6.58-4.33-.45-9.38-5.05-9.38-13.74,0-9.3,6.41-13.71,11.07-13.72,2.45,0,4.39-2.1,4.39-4.55v-14.35c0-1.27-1.03-2.29-2.29-2.29h-22.32c-.83,0-1.41-.85-1.07-1.6.62-1.35.96-2.84.96-4.42,0-7.83-8.44-13.7-16.72-8.99Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M65.24,142.55c.68,1.2,1.69,2.22,2.89,2.9,3.1,1.79,6.22,2.08,8.92,1.34,1.61-.44,3.21.71,3.21,2.38,0,4.22-.06,13.32-.1,18.63-.02,2.26,1.81,4.09,4.07,4.09h53.1c7.58,0,13.72-6.14,13.72-13.72v-54.78c0-1.27-1.03-2.29-2.29-2.29h-13.27c-3.45,0-6.22,2.66-6.58,6.09-.45,4.33-5.05,9.38-13.74,9.38-9.3,0-13.71-6.41-13.72-11.07,0-2.45-2.1-4.39-4.55-4.39h-14.35c-1.27,0-2.29,1.03-2.29,2.29v22.32c0,.83-.85,1.41-1.6,1.07-1.35-.62-2.84-.96-4.42-.96-7.83,0-13.7,8.44-8.99,16.72Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M150.82,86.15c.81-1.12,1.32-2.45,1.45-3.83.34-3.56-.69-6.53-2.48-8.67-1.07-1.28-.68-3.21.84-3.91,3.84-1.75,12.14-5.47,16.99-7.64,2.06-.92,2.97-3.34,2.03-5.4l-22.03-48.31c-3.14-6.89-11.28-9.93-18.17-6.79l-49.84,22.73c-1.15.52-1.66,1.88-1.13,3.03l5.51,12.08c1.43,3.13,5,4.56,8.27,3.46,4.12-1.39,10.63.7,14.23,8.61,3.83,8.39-.08,15.03-4.29,17.03-2.25,1.07-3.24,3.74-2.2,6.01l5.95,13.06c.52,1.15,1.88,1.66,3.03,1.13l20.31-9.26c.75-.34,1.64.19,1.64,1.01,0,1.48.31,2.98.96,4.42,3.25,7.13,13.36,8.96,18.95,1.24Z"
    />
  </svg>
);

export const GridSVG = ({
  className,
  svgColor = "white",
}: {
  className: string;
  svgColor?: string;
}) => {
  return (
    <svg
      viewBox="0 0 172.07 172.07"
      role="img"
      aria-label="Cross icon"
      className={className}
    >
      <g fill={svgColor}>
        <path d="M86.03,9.89c-4.18,0-7.59,3.4-7.59,7.59v49.05c0,4.18,3.4,7.59,7.59,7.59s7.59-3.4,7.59-7.59V17.48   C93.62,13.3,90.22,9.89,86.03,9.89z" />
        <path d="M86.03,97.95c-4.18,0-7.59,3.4-7.59,7.59v49.05c0,4.18,3.4,7.59,7.59,7.59s7.59-3.4,7.59-7.59v-49.05   C93.62,101.35,90.22,97.95,86.03,97.95z" />
        <path d="M64.91,78.45H15.86c-4.18,0-7.59,3.4-7.59,7.59s3.4,7.59,7.59,7.59h49.05c4.18,0,7.59-3.4,7.59-7.59   S69.09,78.45,64.91,78.45z" />
        <path d="M156.21,78.45h-49.05c-4.18,0-7.59,3.4-7.59,7.59s3.4,7.59,7.59,7.59h49.05c4.18,0,7.59-3.4,7.59-7.59   S160.39,78.45,156.21,78.45z" />
      </g>
    </svg>
  );
};

export const BulletSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 306 242.43"
    className={className}
  >
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M295.06,191.55H60.19c-4.86,0-8.67,3.1-8.67,7.05,0,3.95,3.81,7.05,8.67,7.05h234.86c4.86,0,8.67-3.1,8.67-7.05,0-3.95-3.81-7.05-8.67-7.05Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M3.75,205.65h30.34c3.43,0,6.21,2.78,6.21,6.21v29.42c0,1.3-1.56,1.96-2.5,1.06L2.72,208.17c-.95-.92-.29-2.52,1.03-2.52"
      />
    </g>
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M295.06,95.61H60.19c-4.86,0-8.67,3.1-8.67,7.05,0,3.95,3.81,7.05,8.67,7.05h234.86c4.86,0,8.67-3.1,8.67-7.05,0-3.95-3.81-7.05-8.67-7.05Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M3.75,109.71h30.34c3.43,0,6.21,2.78,6.21,6.21v29.42c0,1.3-1.56,1.96-2.5,1.06L2.72,112.23c-.95-.92-.29-2.52,1.03-2.52"
      />
    </g>
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M295.06-.32H60.19c-4.86,0-8.67,3.1-8.67,7.05,0,3.95,3.81,7.05,8.67,7.05h234.86c4.86,0,8.67-3.1,8.67-7.05,0-3.95-3.81-7.05-8.67-7.05Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M3.75,13.77h30.34c3.43,0,6.21,2.78,6.21,6.21v29.42c0,1.3-1.56,1.96-2.5,1.06L2.72,16.3c-.95-.92-.29-2.52,1.03-2.52"
      />
    </g>
  </svg>
);

export const DividerSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 214.58 192.97"
    className={className}
  >
    <path
      fill={resolveColor(accentColor)}
      d="M214.58,96.16c0-2.36-2.27-4.2-5.17-4.2H5.17C2.27,91.96,0,93.8,0,96.16s2.27,4.2,5.17,4.2h204.25c2.9,0,5.17-1.84,5.17-4.2Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M195.7,157.38v-26.59H18.88v26.59c0,19.29,15.64,34.94,34.94,34.94h106.95c19.3,0,34.94-15.64,34.94-34.94Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M195.7,34.94v26.59H18.88v-26.59C18.88,15.64,34.52,0,53.82,0h106.95c19.3,0,34.94,15.64,34.94,34.94Z"
    />
  </svg>
);

export const DoubleQuoteSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 214.58 173.18"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M84.59,75.81h-51.69c-1.73,0-3.13-1.4-3.13-3.13,0-11.28-1.42-21.94,7.38-29l24.68-19.8c4.98-3.99,5.8-11.25,1.85-16.26l-1.96-2.48C57.64-.05,50.06-.79,45.04,3.51l-27.85,23.87C6.28,36.73,0,50.39,0,64.76v95.65c0,7.06,5.73,12.79,12.79,12.79h71.8c7.07,0,12.79-5.73,12.79-12.79v-71.8c0-7.07-5.73-12.79-12.79-12.79Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M201.79,75.81h-51.69c-1.73,0-3.13-1.4-3.13-3.13,0-11.28-1.42-21.94,7.38-29l24.68-19.8c4.98-3.99,5.8-11.25,1.85-16.26l-1.96-2.48c-4.09-5.18-11.67-5.92-16.69-1.63l-27.85,23.87c-10.91,9.35-17.19,23.01-17.19,37.38v95.65c0,7.06,5.73,12.79,12.79,12.79h71.8c7.07,0,12.79-5.73,12.79-12.79v-71.8c0-7.07-5.73-12.79-12.79-12.79Z"
    />
  </svg>
);

export const FaqSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  secondaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 214.58 133.71"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M137.55,3.45H8.31c-3.93,0-7.02,2.5-7.02,5.7,0,3.2,3.08,5.7,7.02,5.7h129.24c3.93,0,7.02-2.5,7.02-5.7,0-3.2-3.08-5.7-7.02-5.7Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M5.15,37.93h135.57c2.84,0,5.15,4.56,5.15,10.19v75.43c0,5.63-2.3,10.19-5.15,10.19H5.15C2.3,133.74,0,129.18,0,123.55V48.12C0,42.49,2.3,37.93,5.15,37.93Z"
    />
    <path
      fill={resolveColor(secondaryColor)}
      d="M212.98,1.61c-2.15-2.16-5.64-2.14-7.75,0l-13.98,13.98-14.42-14.04c-2.17-2.1-5.63-2.03-7.75.12-2.08,2.15-2.04,5.62.1,7.73l22.15,21.57,21.64-21.63c1.03-1.03,1.6-2.4,1.6-3.87s-.56-2.82-1.6-3.87Z"
    />
  </svg>
);

export const HeadingSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 306 242.43"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M294.61,107.17H15.2c-5.78,0-10.31,3.68-10.31,8.38,0,4.7,4.53,8.39,10.31,8.39h279.41c5.78,0,10.31-3.68,10.31-8.39,0-4.7-4.53-8.38-10.31-8.38Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M294.61,166.45H15.2c-5.78,0-10.31,3.68-10.31,8.38,0,4.7,4.53,8.39,10.31,8.39h279.41c5.78,0,10.31-3.68,10.31-8.39,0-4.7-4.53-8.38-10.31-8.38Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M294.61,225.03H15.2c-5.78,0-10.31,3.68-10.31,8.38,0,4.7,4.53,8.39,10.31,8.39h279.41c5.78,0,10.31-3.68,10.31-8.39,0-4.7-4.53-8.38-10.31-8.38Z"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="1.07"
      y=".63"
      width="303.86"
      height="71.19"
      rx="7.57"
      ry="7.57"
    />
  </svg>
);

export const ImageSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 222.37 213.7"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M58.05.41c34.3,1.21,70.34-2.12,104.44-.17,31.45,1.79,52.95,22.92,55.26,54.32-1.69,34.2,2.28,70.61,0,104.56-2.07,30.89-23.52,52.11-54.29,54.29-34.11-1.59-70.17,2.14-104.06,0-31.07-1.96-52.7-23.16-54.79-54.29-2.27-33.8,1.71-70.03-.03-104.09C6.62,24.29,27.19,2.83,58.05.41ZM201.74,112.84l.03-56.81c-1.47-23.2-16.06-38.07-39.28-39.78-33.59,1.87-69.79-2.44-103.08.03-22.93,1.7-37.4,16.93-38.81,39.75-2.03,32.95,1.59,67.95,0,101.11.14,2.08,2.38,14.93,3.78,15.24l40.81-27.23c22.3-12.32,27.87,10.81,46.15,10.53,4.74-.07,9.94-1.9,13.8-4.6,15.02-10.53,29.49-26.76,44.34-38.22,10.5-8.11,21.72-8.18,32.25-.01Z"
    />
    <circle fill={resolveColor(accentColor)} cx="79.16" cy="64.15" r="25.4" />
  </svg>
);

export const ParagraphSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 198.87 123.04"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M189.02,0H9.85C4.33,0,0,3.52,0,8.01c0,4.49,4.33,8.01,9.85,8.01h179.17c5.52,0,9.85-3.52,9.85-8.01C198.87,3.52,194.55,0,189.02,0Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M164.54,53.51H9.85c-5.52,0-9.85,3.52-9.85,8.01,0,4.49,4.33,8.01,9.85,8.01h154.69c5.52,0,9.85-3.52,9.85-8.01,0-4.49-4.33-8.01-9.85-8.01Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M116.01,107.02H9.85c-5.52,0-9.85,3.52-9.85,8.01,0,4.49,4.33,8.01,9.85,8.01h106.16c5.52,0,9.85-3.52,9.85-8.01,0-4.49-4.33-8.01-9.85-8.01Z"
    />
  </svg>
);

export const ProductListSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 306 217.76"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M9.65,1.68h57.55c4.29,0,7.78,3.49,7.78,7.78v57.55c0,4.29-3.49,7.78-7.78,7.78H9.65c-4.29,0-7.78-3.49-7.78-7.78V9.46C1.87,5.16,5.36,1.68,9.65,1.68Z"
    />
    <g>
      <g>
        <path
          fill={resolveColor(primaryColor)}
          d="M208.84,75.8v-30.85c0-3.77-2.4-6.72-5.46-6.72s-5.46,2.95-5.46,6.72v30.85c0,3.77,2.4,6.72,5.46,6.72s5.46-2.95,5.46-6.72Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M173.97,54.91h-60.31c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h60.31c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
        />
        <path
          fill={resolveColor(primaryColor)}
          d="M295.69,11.77H113.67c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h182.02c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M295.69,54.91h-60.31c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h60.31c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
        />
      </g>
      <g>
        <path
          fill={resolveColor(primaryColor)}
          d="M9.65,133.73h57.55c4.29,0,7.78,3.49,7.78,7.78v57.55c0,4.29-3.49,7.78-7.78,7.78H9.65c-4.29,0-7.78-3.49-7.78-7.78v-57.55c0-4.29,3.49-7.78,7.78-7.78Z"
        />
        <g>
          <path
            fill={resolveColor(primaryColor)}
            d="M208.84,211.21v-30.85c0-3.77-2.4-6.72-5.46-6.72s-5.46,2.95-5.46,6.72v30.85c0,3.77,2.4,6.72,5.46,6.72s5.46-2.95,5.46-6.72Z"
          />
          <path
            fill={resolveColor(accentColor)}
            d="M173.97,190.33h-60.31c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h60.31c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
          />
          <path
            fill={resolveColor(primaryColor)}
            d="M295.69,147.18H113.67c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h182.02c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
          />
          <path
            fill={resolveColor(accentColor)}
            d="M295.69,190.33h-60.31c-3.77,0-6.72,2.4-6.72,5.46,0,3.06,2.95,5.46,6.72,5.46h60.31c3.77,0,6.72-2.4,6.72-5.46,0-3.06-2.95-5.46-6.72-5.46Z"
          />
        </g>
      </g>
      <path
        fill={resolveColor(primaryColor)}
        d="M302.4,113.2H106.94c-.95,0-1.72-.76-1.72-1.71s.77-1.71,1.72-1.71h195.46c.95,0,1.72.76,1.72,1.71s-.77,1.71-1.72,1.71Z"
      />
    </g>
  </svg>
);

export const ReferenceSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
  baseColor = "white",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
  baseColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 214.58 238.37"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M157.37,196.66c-1.42,0-2.84-.19-4.25-.58l-88.44-24.22c-4.12-1.13-7.55-3.79-9.68-7.51-2.12-3.72-2.67-8.03-1.54-12.15l30.57-111.64c2.35-8.52,11.16-13.53,19.66-11.21l88.45,24.22c4.12,1.13,7.55,3.8,9.67,7.51,2.12,3.72,2.67,8.03,1.54,12.15l-30.57,111.64c-1.13,4.12-3.79,7.55-7.51,9.67-2.46,1.4-5.17,2.11-7.91,2.11ZM99.48,37.81c-3.07,0-5.89,2.04-6.74,5.15l-30.57,111.63c-.49,1.8-.26,3.68.67,5.3.93,1.62,2.43,2.79,4.23,3.28l88.44,24.22c1.82.49,3.7.25,5.3-.67,1.63-.93,2.79-2.43,3.28-4.22l30.57-111.64c.49-1.8.26-3.68-.67-5.3-.93-1.62-2.43-2.79-4.22-3.28l-88.45-24.22c-.62-.17-1.23-.25-1.84-.25Z"
    />
    <g>
      <path
        fill={resolveColor(baseColor)}
        d="M28.88,6.82h110.55c3.89,0,7.04,3.16,7.04,7.04v139.53c0,3.88-3.15,7.04-7.04,7.04H28.88c-3.89,0-7.04-3.16-7.04-7.04V13.86c0-3.89,3.16-7.04,7.04-7.04Z"
      />
      <g>
        <path
          fill={resolveColor(accentColor)}
          d="M139.43,0H28.88c-7.64,0-13.86,6.22-13.86,13.85v139.54c0,7.64,6.22,13.85,13.86,13.85h110.55c7.64,0,13.86-6.22,13.86-13.85V13.85c0-7.64-6.22-13.85-13.86-13.85ZM146.47,153.39c0,3.88-3.16,7.04-7.04,7.04H28.88c-3.88,0-7.04-3.16-7.04-7.04V13.85c0-3.88,3.16-7.04,7.04-7.04h110.55c3.88,0,7.04,3.16,7.04,7.04v139.54Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M125.91,67.96H57.65c-2.11,0-3.75,1.34-3.75,3.05s1.65,3.05,3.75,3.05h68.26c2.1,0,3.75-1.34,3.75-3.05s-1.65-3.05-3.75-3.05Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M125.91,47.58H57.65c-2.11,0-3.75,1.34-3.75,3.05s1.65,3.05,3.75,3.05h68.26c2.1,0,3.75-1.34,3.75-3.05s-1.65-3.05-3.75-3.05Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M125.91,27.2h-40.44c-2.1,0-3.75,1.34-3.75,3.05s1.65,3.05,3.75,3.05h40.44c2.1,0,3.75-1.34,3.75-3.05s-1.65-3.05-3.75-3.05Z"
        />
      </g>
    </g>
    <path
      fill={resolveColor(primaryColor)}
      d="M205.47,115.88H70.6c-2.33,0-4.4-1.5-5.13-3.72l-.96-2.94c-.67-2.05-2.58-3.43-4.73-3.43H3.46c-1.91,0-3.46,1.29-3.46,2.89v120.59c0,5.03,4.08,9.11,9.11,9.11h196.36c5.03,0,9.11-4.08,9.11-9.11v-104.28c0-5.03-4.08-9.11-9.11-9.11ZM88.84,215.79c0,2.66-2.15,4.81-4.81,4.81H22.13c-2.66,0-4.81-2.15-4.81-4.81v-14.33c0-2.66,2.15-4.81,4.81-4.81h61.91c2.65,0,4.81,2.15,4.81,4.81v14.33Z"
    />
  </svg>
);

export const TableSVG = ({
  className,
  svgColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 57.87 68.3"
    className={className}
  >
    <rect fill="transparent" width="57.87" height="68.3" />
    <g>
      <rect
        fill={resolveColor(svgColor)}
        x="4.38"
        y="19.44"
        width="46.87"
        height="1.86"
      />
      <rect
        fill={resolveColor(svgColor)}
        x="4.38"
        y="38.09"
        width="46.87"
        height="1.86"
      />
      <rect
        fill={resolveColor(svgColor)}
        x="4.38"
        y="56.75"
        width="46.87"
        height="1.86"
      />
      <g>
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,10.29c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,14.04c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,17.8c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,21.55c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,25.3c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,29.05c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,32.8c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,36.55c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,40.31c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,44.06c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,47.81c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,51.56c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,55.31c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,59.06c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,62.81c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M20.1,66.57c-.5,0-.9.39-.9.87s.41.87.9.87.9-.39.9-.87-.4-.87-.9-.87Z"
        />
      </g>
      <g>
        <path
          fill={resolveColor('black')}
          d="M55.34,1.91h-.43v2h.43c.78-.23,1.56-.46,2.34-.69.25-.2.25-.4,0-.59l-2.34-.72Z"
        />
        <rect
          fill={resolveColor("black")}
          x="40.42"
          y="1.82"
          width="1.16"
          height="2.07"
        />
        <rect
          fill={resolveColor("black")}
          x="52.49"
          y="1.86"
          width="1.16"
          height="2.04"
        />
        <rect
          fill={resolveColor("black")}
          x="45.25"
          y="1.83"
          width="1.16"
          height="2.07"
        />
        <rect
          fill={resolveColor("black")}
          x="47.67"
          y="1.83"
          width="1.16"
          height="2.07"
        />
        <rect
          fill={resolveColor("black")}
          x="42.84"
          y="1.84"
          width="1.16"
          height="2.07"
        />
        <path
          fill={resolveColor("black")}
          d="M50.5,2.21h.55s.01,1.35.01,1.35h-.56v.42h.79V1.8h-.79v.41ZM49.64,1.22c.42-.1.84-.2,1.26-.31.58-.14.98-.04.97.71v2.44c0,.75-.3.94-.93.76l-1.26-.36c-.15-.08-.22-.21-.23-.37V1.54c0-.17.07-.26.19-.32"
        />
      </g>
      <g>
        <path
          fill={resolveColor(svgColor)}
          d="M37.62,1.25H7.5c-.82,0-1.46.71-1.46,1.63,0,.91.64,1.63,1.46,1.63h30.12c.82,0,1.46-.71,1.46-1.63,0-.91-.64-1.63-1.46-1.63Z"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M.17,0h3.49c.39,0,.71.32.71.71v3.39c0,.15-.18.23-.29.12L.05.29c-.11-.11-.03-.29.12-.29"
        />
      </g>
    </g>
  </svg>
);

export const OverlaySVG = ({
  className,
  primaryColor = "#808285",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 114.46 114.25"
    className={className}
  >
    <path
      fill="none"
      stroke={resolveColor(primaryColor)}
      strokeMiterlimit="10"
      strokeWidth="4.62"
      d="M97.06,100.23c2.59,0,4.69-2.1,4.69-4.69V17.31c0-2.59-2.1-4.69-4.69-4.69H22.39c-2.59,0-4.69,2.1-4.69,4.69"
    />
    <path
      fill="none"
      stroke={resolveColor(primaryColor)}
      strokeMiterlimit="10"
      strokeWidth="4.62"
      d="M107.5,78.08c2.59,0,4.69-2.1,4.69-4.69V7.08c0-2.59-2.1-4.69-4.69-4.69H39.47c-2.59,0-4.69,2.1-4.69,4.69"
    />
    <rect
      fill={"transparent"}
      stroke={resolveColor(accentColor)}
      strokeMiterlimit="10"
      strokeWidth="4.62"
      x="2.27"
      y="23.71"
      width="88.15"
      height="88.15"
      rx="4.69"
      ry="4.69"
    />
    <g>
      <rect
        fill={resolveColor(accentColor)}
        x="39.03"
        y="53.84"
        width="36.8"
        height="4.25"
        rx="1.96"
        ry="1.96"
        transform="translate(114.85 111.92) rotate(180)"
      />
      <rect
        fill={resolveColor(accentColor)}
        x="16.87"
        y="65.66"
        width="58.96"
        height="4.25"
        rx="2.12"
        ry="2.12"
        transform="translate(92.69 135.57) rotate(-180)"
      />
      <rect
        fill={resolveColor(accentColor)}
        x="16.87"
        y="77.49"
        width="58.96"
        height="4.25"
        rx="2.12"
        ry="2.12"
        transform="translate(92.69 159.23) rotate(180)"
      />
    </g>
  </svg>
);

export const ArticlePlaceholderSVG = ({
  className,
  secondaryColor = "white",
  detailColor = "#d1d3d4",
}: {
  className: string;
  secondaryColor?: string;
  detailColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 129 82.28"
    className={className}
  >
    <g>
      <rect
        fill={resolveColor(secondaryColor)}
        x="38.94"
        y="19.56"
        width="43.39"
        height="42.62"
      />
      <rect
        fill={resolveColor(secondaryColor)}
        x="81.18"
        y="39.57"
        width="9.69"
        height="21.76"
      />
      <g>
        <g>
          <path
            fill={resolveColor(detailColor)}
            d="M70.05,38.83h-21.67c-1.2,0-2.17.97-2.17,2.17,0,1.18.94,2.14,2.12,2.17.01,0,.03,0,.04,0,6.89.14,14.98.13,21.67,0,.01,0,.03,0,.04,0,1.2-.02,2.15-1.01,2.12-2.21-.02-1.18-.99-2.12-2.17-2.12Z"
          />
          <path
            fill={resolveColor(detailColor)}
            d="M69.68,48.74h-7.48c-1.2,0-2.17.97-2.17,2.17,0,1.18.94,2.14,2.12,2.17.01,0,.03,0,.04,0,6.89.14.8.13,7.48,0,.01,0,.03,0,.04,0,1.2-.02,2.15-1.01,2.12-2.21-.02-1.18-.99-2.12-2.17-2.12Z"
          />
          <path
            fill={resolveColor(detailColor)}
            d="M70.05,28.92h-21.67c-1.2,0-2.17.97-2.17,2.17,0,1.18.94,2.14,2.12,2.17.01,0,.03,0,.04,0,6.89.14,14.98.13,21.67,0,.01,0,.03,0,.04,0,1.2-.02,2.15-1.01,2.12-2.21-.02-1.18-.99-2.12-2.17-2.12Z"
          />
        </g>
        <path
          fill={resolveColor(detailColor)}
          d="M93.82,43.21c-.04-3.17-2.38-5.96-5.59-6.38-1.47-.19-3.05-.26-4.71-.29.29-4.44.65-8.97,1.05-13.44.32-3.5-2.26-6.67-5.76-7.05-5.62-.6-11.86-.91-18.01-.83-6.15.08-12.23.54-17.53,1.48-2.59.46-4.7,2.44-5.25,5.04-1.78,8.37-4.31,24.69-1.76,35.3,1.09,4.53,4.75,8.08,9.4,8.84,10.92,1.79,24.21,1.49,35.15.22,1.02-.11,2.43-.44,3.78-.74,1.35-.31,2.52-.59,2.53-.6h.02c.18-.05.35-.12.51-.2,1.66-.57,2.89-1.86,3.67-3.32.88-1.63,1.39-3.53,1.75-5.58.73-4.09.8-8.79.75-12.45ZM80.32,61.8h-.01c-10.61,1.23-23.66,1.5-33.95-.19-2.89-.48-5.19-2.68-5.89-5.58-2.14-8.88.08-25.39,1.78-33.39.19-.88.85-1.51,1.76-1.68,4.98-.88,10.85-1.32,16.82-1.4,5.98-.08,12.07.21,17.51.8,1.19.13,2.02,1.14,1.91,2.35-.46,5.08-.9,10.28-1.2,15.35h0c-.09.31-.11.63-.06.94-.38,6.87-.43,13.41.42,18.69.26,1.61,1.03,2.76,1.76,3.94-.24.04-.77.16-.86.17ZM88.8,54.9c-.32,1.78-.78,3.32-1.3,4.29-.52.98-.95,1.26-1.32,1.34-.02,0-.03,0-.05.01h0c-.5.12-.68.08-1.14-.39-.46-.47-1.02-1.52-1.28-3.15-.7-4.34-.72-9.99-.44-16.13,1.64.03,3.14.08,4.42.25,1.03.13,1.8,1.03,1.82,2.14.04,3.55-.05,8.07-.69,11.64Z"
        />
      </g>
    </g>
  </svg>
);

export const UrlSVG = ({
  className,
  svgColor = "pinkCustom",
}: {
  className: string;
  svgColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 198.87 206.3"
    className={className}
  >
    <path
      fill={resolveColor(svgColor)}
      d="M145.44,4.91c43.15-2.88,68.37,47.97,40.59,80.83-14.51,12.96-27.55,29.56-42.16,42.17-18.23,15.74-46.43,15.92-64.46-.25-7.77-6.96-8.52-18.79,2.42-22.51,9.13-3.11,11.67,3.58,18.24,7.12,9.59,5.16,20.33,3.41,28.47-3.53,13.2-11.27,24.96-26.48,38.09-38.09,17.67-20.9-4.13-49.73-28.13-39.15-10.12,4.46-22.97,24.69-30.9,26.6-11.48,2.76-20.08-9.44-13.54-18.81,3.31-4.74,17.85-18.64,22.72-22.79,7.77-6.63,18.43-10.91,28.65-11.59Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M84.12,66.23c12.42-.83,31.26,5.02,38.9,15.43,6.09,8.29.49,19.91-9.82,19.92-6.55,0-9.29-5.39-14.46-8.1-7.84-4.12-17.93-3.54-25.22,1.45-12.79,13.39-29.82,26.75-41.52,40.89-15.86,19.17,1.69,46.33,25.74,39.64,12.85-3.58,25.31-26.23,34.49-27.8,11.54-1.97,19.38,10.39,12.35,19.54-4.27,5.56-21.2,22.02-26.93,25.77-47.59,31.11-100.61-29.53-64.59-72.74,21.89-17.9,40.38-51.94,71.06-53.99Z"
    />
  </svg>
);

export const VideoSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 198.87 206.3"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M18.12.89l160.96-.13c9.31.7,16.54,6.8,19.04,15.74,1.06,37.84.91,76.11.08,113.97-1.97,7.57-7.56,13.5-15.19,15.45-55.51,1.06-111.43.91-166.96.08-8.91-2.26-15.17-9.56-16.05-18.73V19.62C1.18,9.9,8.38,2.35,18.12.89ZM19.35,14.13c-3.42.81-5.91,3.57-6.12,7.13v104.78c.23,3.93,3.33,7.02,7.25,7.25h157.78c3.93-.23,7.02-3.33,7.25-7.25V21.26c-.23-3.93-3.33-7.02-7.25-7.25l-158.91.12Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M85.82,44.94c1.26-.2,2.36-.05,3.47.58l38.57,24.11c2.85,2.04,2.86,6.01,0,8.06l-38.57,24.11c-3.25,1.83-7.13-.29-7.31-3.98v-48.59c.16-2.02,1.85-3.95,3.83-4.27Z"
    />
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M188.28,176.7H6.7c-3.76,0-6.7,2.39-6.7,5.45,0,3.06,2.94,5.45,6.7,5.45h181.58c3.76,0,6.7-2.39,6.7-5.45,0-3.06-2.94-5.45-6.7-5.45Z"
      />
      <path
        fill={resolveColor(primaryColor)}
        d="M126.94,158.54l19.91,19.91c2.25,2.25,2.25,5.9,0,8.15l-19.3,19.3c-.85.85-2.31.26-2.33-.95l-.61-45.43c-.02-1.22,1.46-1.85,2.33-.98"
      />
    </g>
  </svg>
);

export const ReorderSVG = ({
  className,
  accentColor = "pinkCustom",
  secondaryColor = "#606060",
}: {
  className: string;
  accentColor?: string;
  secondaryColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 220.65 165.38"
    className={className}
  >
    <path
      fill={resolveColor(accentColor)}
      d="M203.78,33.75H16.87C7.55,33.75,0,26.2,0,16.87S7.55,0,16.87,0h186.9c9.33,0,16.87,7.55,16.87,16.87s-7.55,16.87-16.87,16.87Z"
    />
    <path
      fill={resolveColor(secondaryColor)}
      d="M203.78,99.57H16.87c-9.33,0-16.87-7.55-16.87-16.87s7.55-16.87,16.87-16.87h186.9c9.33,0,16.87,7.55,16.87,16.87s-7.55,16.87-16.87,16.87Z"
    />
    <path
      fill={resolveColor(secondaryColor)}
      d="M203.78,165.38H16.87c-9.33,0-16.87-7.55-16.87-16.87s7.55-16.87,16.87-16.87h186.9c9.33,0,16.87,7.55,16.87,16.87s-7.55,16.87-16.87,16.87Z"
    />
  </svg>
);

export const PasteSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 221.97 230.81"
    className={className}
  >
    <path
      fill={resolveColor(accentColor ?? primaryColor)}
      d="M175.74,50.49c0-6.54-6.11-17.47-10.77-22-13.28-12.9-29.75-9.76-46.71-10.13-2.06-7.02-7.65-13.15-14.44-15.86-7.5-3-24.03-3.01-31.57-.13-6.96,2.67-12.67,8.85-14.76,15.99-9.92.7-20.85-1.23-30.51,1.17C12.07,23.23,1.24,36.61,0,51.81l.02,145.33c1.3,16.47,15.29,31.29,31.9,32.97,14.26,1.44,30.88-1.08,45.39,0,10.21-2.86,9.46-17-1.56-17.96-13.06-1.13-27.8,1.06-40.93.03-9.26-.73-16.35-8.02-16.86-17.26l.03-142.2c1.01-9.58,9.16-16.8,18.87-16.38v28.03c0,3.29,4.93,7.57,8.32,7.4l85.4.02c3.69.55,9.19-3.81,9.19-7.42v-28.03c7.56,0,14.51,4.88,16.98,11.98.21.59,1,3.15,1,3.49v37.77h17.98v-39.11ZM121.81,53.85H54.85v-17.49h11.01c.38,0,3.15-1.32,3.7-1.69,6.36-4.19,1.37-15.41,12.91-16.27,3.84-.29,12.58-.53,15.68,1.44,5.56,3.54,2.54,11.73,8.6,15.19.41.23,2.99,1.33,3.16,1.33h11.91v17.49Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M210.29,194.33c-10.18,2.18-3.22,16.37-14.62,17.7l-66.47.03c-4.79-.48-8.07-3.89-8.34-8.73v-86.6c.04-5.01,3.35-8.67,8.34-9.17,21.19,1.36,44.71-1.83,65.63-.02,4.87.42,8.24,3.35,8.74,8.32,1.34,13.29-1.17,28.77-.01,42.17,1.01,11.69,16.87,11.45,17.99.43-2.09-16.77,5.12-45.08-5.85-58.74-3.43-4.27-12.18-10.1-17.74-10.1h-71.46c-12.02,0-23.61,14-23.61,25.32,0,27.37.15,84.34.15,91.4,0,12.49,11.13,21.45,23.25,23.67h71.46c11.87-1.27,22.67-12.16,23.76-24.05.66-7.12-3.36-13.32-11.21-11.63Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M176.85,125.49c-6.78-.59-24-.81-30.46.13-10.11,1.48-10.34,16.84,1.21,17.84,7.12.62,23.13.77,30.08-.07,10.5-1.26,10.85-16.9-.83-17.91Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M176.85,156.89c-6.78-.59-24-.81-30.46.13-10.11,1.48-10.34,16.84,1.21,17.84,7.12.62,23.13.77,30.08-.07,10.5-1.26,10.85-16.9-.83-17.91Z"
    />
  </svg>
);

export const CopySVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 222.25 221.24"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M19.72,60.88l120.84-.16c9.88.69,17.31,6.11,19.79,15.84.98,42.77.98,85.92,0,128.7-1.93,7.76-7.48,13.31-15.24,15.24-42.77.98-85.92.98-128.7,0-7.76-1.93-13.31-7.48-15.24-15.24C.2,162.49.2,119.34,1.18,76.57c2.16-8.92,9.41-14.98,18.54-15.69Z"
    />
    <path
      fill={resolveColor(accentColor ?? primaryColor)}
      d="M79.73.87l120.84-.16c9.88.69,17.31,6.11,19.79,15.84.98,42.77.98,85.92,0,128.7-2.48,9.72-9.91,15.16-19.79,15.84-8.98.62-19 .66-19.96-10.55-2.18-25.28,1.71-53.6-.04-79.2-2.19-15.77-14.83-28.3-30.66-30.29-25.45-1.65-53.65,2.17-78.78,0-11.36-.98-11.22-11.37-10.53-20.41.85-11.05,8.03-18.72,19.12-19.79Z"
    />
  </svg>
);

export const LoadImageSVG = ({
  className,
  backgroundColor = "#28195a",
  foregroundColor = "white",
}: {
  className: string;
  backgroundColor?: string;
  foregroundColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 221.74 221.24"
    className={className}
  >
    <rect
      fill={resolveColor(backgroundColor)}
      x=".25"
      width="221.24"
      height="221.24"
      rx="13.12"
      ry="13.12"
    />
    <path
      fill={resolveColor(foregroundColor)}
      d="M167.11,94.3c-1.19-.56-2.02-1.69-2.14-3-2.12-24.22-22.66-43.39-47.32-43.39-13.76,0-27.09,6.18-36.05,16.65-.4.46-.99.68-1.59.59-1.29-.19-2.59-.29-3.89-.29-14.63,0-26.53,11.9-26.53,26.53,0,1.46.12,2.91.37,4.34.11.66-.15,1.32-.69,1.72-9.12,6.73-14.04,18-12.65,29.38,1.91,15.85,15.83,27.81,32.35,27.81h83.86c15.83,0,29.32-10.92,32.04-25.98,2.56-14.18-4.97-28.36-17.76-34.37ZM171.39,138.31c-4.47,5.14-10.91,8.08-17.69,8.08h-84.9c-11,0-20.58-7.03-23.3-17.08-2.91-10.67,1.79-21.75,11.44-26.96l1.79-.97c.75-.41,1.09-1.3.81-2.1l-.67-1.91c-.67-1.97-1.02-3.98-1.02-5.98,0-10.08,8.2-18.28,18.27-18.28,1.78,0,3.56.26,5.28.78l1.62.49c.71.21,1.47-.04,1.91-.63h0c6.19-8.47,15.07-15.04,25.39-16.92,24.86-4.52,46.58,14.51,46.56,38.82-.01.24-.03.47-.03.66l-.05,1.86c-.02.8.51,1.51,1.28,1.72l1.13.31c9.45,2.59,16.38,10.18,17.68,19.35.97,6.89-.98,13.55-5.49,18.75Z"
    />
    <g>
      <path
        fill={resolveColor(foregroundColor)}
        d="M106.07,124.61c3.32,0,4.9,1.46,7.05,3.63,12.2,12.35,23.23,25.96,35.38,38.38,4.58,4.67,1.23,12.37-5.35,12.03-6.82-.35-16.05-3.75-22.42-1.22-5.62,2.23-10.81,10.13-15.6,14.03-2.3,1.87-5.05,2.35-7.79.97-5.52-2.78-3.48-9.15-3.09-14.05,1.28-15.8,2.64-31.59,4.12-47.39,0-.1.03-.2.05-.3.84-3.36,4.17-6.08,7.64-6.08Z"
      />
      <path
        fill={resolveColor(backgroundColor)}
        d="M100.54,194.45c-1.25,0-2.51-.31-3.73-.93-5.37-2.7-4.64-8.25-4.05-12.71.11-.87.22-1.71.29-2.52,1.3-16.13,2.69-32.07,4.13-47.42,0-.1.02-.19.05-.29.99-4.11,4.84-7.19,8.86-7.19,3.7,0,5.54,1.58,7.92,3.99,6.29,6.36,12.35,13.16,18.21,19.72,5.54,6.21,11.28,12.64,17.18,18.67,2.5,2.54,3.16,6.11,1.72,9.29-1.34,3.01-4.21,4.82-7.54,4.82-.16,0-.31,0-.47,0-2.31-.12-4.78-.56-7.41-1.03-5.16-.9-10.52-1.86-14.5-.29-3.3,1.31-6.55,4.85-9.7,8.27-1.92,2.11-3.75,4.09-5.58,5.57-1.68,1.36-3.51,2.05-5.36,2.05ZM106.07,125.83c-2.86,0-5.73,2.29-6.45,5.13-.03.1-.04.2-.05.3-1.41,15.18-2.8,31.11-4.09,47.22-.08.85-.19,1.74-.31,2.65-.66,5.01-.82,8.43,2.73,10.22,2.77,1.4,5.06.31,6.46-.83,1.7-1.38,3.47-3.31,5.34-5.34,3.33-3.63,6.78-7.37,10.59-8.89,4.61-1.83,10.31-.83,15.82.15,2.54.46,4.95.89,7.11.99.11,0,.23,0,.34,0,2.79,0,4.56-1.71,5.32-3.38.79-1.76.88-4.42-1.25-6.58-5.94-6.08-11.69-12.52-17.25-18.76-5.84-6.55-11.88-13.31-18.12-19.63-2.06-2.09-3.36-3.27-6.18-3.27Z"
      />
    </g>
  </svg>
);

export const TagSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 219.03 263.81"
    className={className}
  >
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M141.41,1.66L12.46,1.22C5.69,1.42.23,6.89,0,13.78l.45,170.64c.5,4.14,6.44,9.62,10.4,9.62h89.13v-16.41H16.44V17.66h118.2v129.97h16.42V12.05c0-3.98-5.52-9.92-9.66-10.4Z"
      />
      <rect
        fill={resolveColor(primaryColor)}
        x="38.17"
        y="58.1"
        width="76.51"
        height="13.29"
        rx="5.88"
        ry="5.88"
      />
      <path
        fill={resolveColor(primaryColor)}
        d="M108.81,83.97H44.05c-3.24,0-5.88,2.64-5.88,5.88v1.54c0,3.24,2.64,5.88,5.88,5.88h64.76c3.24,0,5.88-2.64,5.88-5.88v-1.54c0-3.24-2.64-5.88-5.88-5.88Z"
      />
      <path
        fill={resolveColor(primaryColor)}
        d="M44.05,109.83c-3.24,0-5.88,2.64-5.88,5.88v1.54c0,3.24,2.64,5.88,5.88,5.88h36.26c3.24,0,5.88-2.64,5.88-5.88v-1.54c0-3.24-2.64-5.88-5.88-5.88h-36.26Z"
      />
    </g>
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M99.72,146.37c.82-1.28,1.98-2.23,3.52-2.41l50.87-4.99,2.87.61,60.81,60.62c1.38,1.46,1.62,3.6.63,5.33l-56.85,57.05c-1.46,1.38-3.6,1.62-5.33.63l-61.43-61.43-.58-2.46,5.5-52.94ZM152.68,148.23l-42.47,4.35-1.9.8-4.87,44.08,55.05,55.05,49.23-49.23-55.05-55.05Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M146.54,168.32c6.36,6.36,6.36,16.66,0,23.02-6.36,6.36-16.66,6.36-23.02,0-6.36-6.36-6.36-16.66,0-23.02,6.36-6.36,16.66-6.36,23.02,0ZM139.93,174.92c-2.71-2.71-7.09-2.71-9.8,0-2.71,2.71-2.71,7.09,0,9.8,2.71,2.71,7.09,2.71,9.8,0,2.71-2.71,2.71-7.09,0-9.8Z"
      />
    </g>
  </svg>
);

export const CalendarSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 221.97 222.22"
    className={className}
  >
    <path
      fill={resolveColor(primaryColor)}
      d="M55.91.56c2.81.59,6.93,4.18,6.93,7.15v10.19h39.01V7.72c0-2.97,4.13-6.56,6.93-7.15h3.47c2.81.59,6.93,4.18,6.93,7.15v10.19h39.44V7.72c0-2.97,4.13-6.56,6.93-7.15h3.47c2.81.59,6.93,4.18,6.93,7.15v10.19h14.95c6.26,0,16.47,5.72,20.87,10.12,5.58,5.58,8.75,12.97,10.12,20.66v97.55c-2.21,8.4-13.36,9.53-16.79,1.4-1.31-32.05-.12-64.37-.6-96.51-.16-7.13-8.17-15.88-15.33-15.88h-13.22v10.19c0,3.68-4.95,7.12-8.45,7.19-3.68.07-8.88-3.3-8.88-7.19v-10.19h-39.44v10.19c0,3.68-4.95,7.12-8.45,7.19-3.68.07-8.88-3.3-8.88-7.19v-10.19h-39.01v10.19c0,3.68-4.95,7.12-8.45,7.19-3.68.07-8.88-3.3-8.88-7.19v-10.19h-12.79c-7.33,0-15.34,8.98-15.38,16.27l-.02,137.01c.74,9.33,7.35,15.9,16.69,16.69l154.31-.02c7.3-.84,13.35-5.16,15.41-12.34,1.36-4.74.11-10.16,5.48-12.73,5.48-2.62,11.12.34,12.71,6-.14,1.82.19,3.86,0,5.64-1.7,15.96-15.95,29.52-31.86,30.77l-157.78.02C15.27,221.19,1.59,207.63,0,190.67V49.78c.22-14.5,16.42-31.87,30.98-31.87h14.52V7.72c0-2.97,4.13-6.56,6.93-7.15h3.47Z"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="98.08"
      y="144.3"
      width="25.81"
      height="25.81"
      rx="5.34"
      ry="5.34"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M155.93,144.3h15.13c2.95,0,5.34,2.39,5.34,5.34v15.13c0,2.95-2.39,5.34-5.34,5.34h-15.13c-2.95,0-5.34-2.39-5.34-5.34v-15.13c0-2.95,2.39-5.34,5.34-5.34Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M178.71,134.28h-30.44c-4.24,0-7.7,3.46-7.7,7.7v30.43c0,4.24,3.46,7.7,7.7,7.7h30.44c4.24,0,7.7-3.46,7.7-7.7v-30.43c0-4.25-3.46-7.7-7.7-7.7ZM184.31,172.42c0,3.09-2.51,5.6-5.6,5.6h-30.44c-3.09,0-5.6-2.51-5.6-5.6v-30.43c0-3.09,2.51-5.6,5.6-5.6h30.44c3.09,0,5.6,2.51,5.6,5.6v30.43Z"
    />
    <g>
      <rect
        fill={resolveColor(accentColor)}
        x="45.57"
        y="83.33"
        width="25.81"
        height="25.81"
        rx="5.34"
        ry="5.34"
      />
      <rect
        fill={resolveColor(accentColor)}
        x="45.57"
        y="144.3"
        width="25.81"
        height="25.81"
        rx="5.34"
        ry="5.34"
      />
      <rect
        fill={resolveColor(accentColor)}
        x="98.08"
        y="83.33"
        width="25.81"
        height="25.81"
        rx="5.34"
        ry="5.34"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M155.93,83.33h15.13c2.95,0,5.34,2.39,5.34,5.34v15.13c0,2.95-2.39,5.34-5.34,5.34h-15.13c-2.95,0-5.34-2.39-5.34-5.34v-15.13c0-2.95,2.39-5.34,5.34-5.34Z"
      />
    </g>
  </svg>
);

export const TimeSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 221.97 230.81"
    className={className}
  >
    <path
      fill={resolveColor(accentColor)}
      d="M54.2,210.86c.75,4.98,1.24,10.18-3.34,13.44-6.22,4.44-13.85,1.41-15.91-5.78-2.92-10.2-3.66-22.83-5.7-33.3.65-3.15,2.15-6.13,5.07-7.73,3.18-1.74,26.81-9.67,30.19-10.03,8.29-.88,14.05,8.53,9.49,15.66-2.81,4.39-8.73,4.88-13.17,6.7-.45.19-1.08.05-.94.7,11.79,7.29,24.75,12.73,38.61,14.6,64.92,8.77,117.15-50.78,99.91-114.1C181.59,29.25,106.73,4.32,55.67,43.26c-3.06,2.33-9.07,8.76-11.87,9.88-7.85,3.15-15.49-2.94-14.07-11.24.78-4.55,9.46-11.37,13.18-14.25,61.99-48.01,153.73-18.03,174.79,57.31,24.08,86.14-57.54,163.85-142.46,135.37-7.33-2.46-14.12-6.1-21.02-9.47Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M116.15,110.13h36.18c2.22,0,5.75,2.47,7.1,4.25,4.56,5.96,1.14,14.13-5.89,15.88-15.34-.84-33.48,1.83-48.5.21-5.06-.55-9.03-4.57-9.24-9.68l.23-63.18c2.19-8.98,14.27-10.86,18.72-2.59.31.58,1.4,3.4,1.4,3.8v51.31Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M8.68,96.53c5.93-1,11.64,3.63,11.96,9.6.09,1.73-.28,6.66-.52,8.45-1.27,9.52-15.24,11.41-19.11,2.64-1.7-3.84-1.16-12.8,1.09-16.41,1.29-2.06,4.21-3.88,6.59-4.29Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M17.66,61.53c7.96-1.37,13.82,4.29,12.31,12.31-.26,1.38-3.05,7.15-3.94,8.36-6.37,8.59-21.28,1.99-17.32-10.22,1.35-4.16,4.21-9.62,8.95-10.44Z"
    />
    <path
      fill={resolveColor(primaryColor)}
      d="M13.89,133.9c3.1-.11,6.86,1.82,8.63,4.36.94,1.34,3.06,7.39,3.26,9.03,1.56,12.21-14.88,16.45-19.58,4.92-.56-1.38-1.95-5.56-2.1-6.9-.65-5.69,4.07-11.21,9.78-11.42Z"
    />
  </svg>
);

export const SettingsAltSVG = ({
  className,
  primaryColor = "var(--color-gray-500)",
  accentColor = "pinkCustom",
}: {
  className: string;
  primaryColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 221.97 169.24"
    className={className}
  >
    <g>
      <path
        fill={resolveColor(primaryColor)}
        d="M12.31,54h197.35c6.8,0,12.31-5.51,12.31-12.32s-5.5-12.31-12.31-12.31H12.31C5.52,29.37,0,34.89,0,41.68s5.51,12.32,12.31,12.32Z"
      />
      <path
        fill={resolveColor(primaryColor)}
        d="M209.66,115.23H12.31C5.52,115.23,0,120.74,0,127.54s5.51,12.31,12.31,12.31h197.35c6.8,0,12.31-5.51,12.31-12.31s-5.5-12.31-12.31-12.31Z"
      />
    </g>
    <path
      fill={resolveColor(accentColor)}
      d="M151.81.7l34.48,34.48c3.9,3.9,3.9,10.22,0,14.12l-33.42,33.42c-1.48,1.48-4,.46-4.03-1.64l-1.05-78.68c-.03-2.12,2.53-3.2,4.03-1.7"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M65.92,86.53l-34.48,34.48c-3.9,3.9-3.9,10.22,0,14.12l33.42,33.42c1.48,1.48,4,.46,4.03-1.64l1.05-78.68c.03-2.12-2.53-3.2-4.03-1.7"
    />
  </svg>
);

export const CaptionSVG = ({
  className,
  accentColor = "#6d6e71",
  svgColor = "#c43291",
}: {
  className?: string;
  accentColor?: string;
  svgColor?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 148.92 69.27"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect
        fill={resolveColor(svgColor)}
        x="49.44"
        y="44.99"
        width="79.49"
        height="6.08"
        rx="2.81"
        ry="2.81"
        transform="translate(178.37 96.05) rotate(180)"
      />
      <rect
        fill={resolveColor(svgColor)}
        x="60.66"
        y="31.99"
        width="68.26"
        height="6.08"
        rx="2.81"
        ry="2.81"
        transform="translate(189.59 70.05) rotate(180)"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M27.3,6.1c-2.91,3.21-4.74,5.21-6.1,5.84-1.18.51-2.78.44-4.45.38-.49-.03-.96-.04-1.38-.04-.22,0-.43,0-.63.01-7.74.71-13.58,6.66-14.18,14.5-.57,7.29-.68,21.33.04,28.55.76,7.55,6.72,13.25,14.47,13.86h118.9c7.59-.54,13.68-6.51,14.35-14.17.68-7.51.65-22.09-.03-28.89-.74-7.47-6.81-13.29-14.46-13.86H49.48l-.39-.22c-1.95-1.06-4.07-3.36-6.31-5.81-2.32-2.54-5.23-5.71-6.98-6.08-.58-.11-1.18-.11-1.77,0-.35.1-1.52.74-2.04,1.13-1.04.78-2.98,2.92-4.69,4.81ZM34.47,10.69c1.33-.24,2.28.72,4.98,3.53,1.9,1.97,5.45,5.67,6.98,5.92l88.68.26c2.79.97,4.48,2.82,5.3,5.83l.06.47-.28,29.35c-1.22,3.03-3.35,4.8-6.33,5.26l-120.16-.28c-2.82-1.15-4.53-3.06-5.2-5.84l.19-29.7c1.96-5.59,6.73-5.39,10.54-5.35,2.24.07,4.38.13,5.88-.81.75-.46,3.16-2.96,4.74-4.62,3.24-3.39,3.77-3.88,4.62-4.03Z"
      />
    </svg>
  );
};

export const ThreeDViewerSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.28 4.98"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M5.6,1.03L3.96.08c-.19-.11-.41-.11-.6,0l-1.64.94c-.19.11-.3.3-.3.52v1.89c0,.21.11.41.3.52l1.64.94c.09.05.2.08.3.08s.21-.03.3-.08l1.64-.94c.19-.11.3-.3.3-.52v-1.89c0-.21-.11-.41-.3-.52ZM3.52.36s.09-.04.14-.04.09.01.14.04l1.61.93s-1.18.66-1.6.86c-.09.04-.19.04-.27,0l-1.61-.85,1.6-.92ZM1.89,3.67l-.14-.24v-1.87s1.38.73,1.7.89c.04.02.06.06.06.11v2.04s-1.62-.93-1.62-.93ZM5.43,3.67l-1.6.92v-2.02s.03-.09.07-.11c.31-.16,1.66-.89,1.66-.89v1.86l-.14.24Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M6.49,1.68v.33c.43.17.45.3.45.39,0,.36-1.26.87-3.31.87S.34,2.76.34,2.4c0-.07,0-.22.49-.4v-.33C.36,1.83,0,2.04,0,2.4,0,3.19,1.83,3.6,3.64,3.6s3.64-.41,3.64-1.2c0-.35-.35-.56-.79-.72Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M1.18,1.59l-.66-.04c-.05,0-.09.05-.07.1l.29.59s.09.05.12,0l.36-.55s0-.1-.05-.11Z"
    />
    <path
      fill={resolveColor(svgColor)}
      d="M6.16,1.6l.66-.04c.05,0,.09.05.07.1l-.29.59s-.09.05-.12,0l-.36-.55s0-.1.05-.11Z"
    />
  </svg>
);

export const NotFoundSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 720.46 722.2"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <g>
        <path
          fill="#28195a"
          d="M241.79,94.07h15.99v24.08h-15.99v31.97h-31.35v-31.97h-58.96l-1.66-18.69L210.23,2.92l31.56-.42v91.56ZM180.12,94.07h30.31v-50.87l-2.08,3.74-28.24,47.13Z"
        />
        <path
          fill="#28195a"
          d="M389.05,136.01c-8.72,10.8-21.18,16.19-37.37,16.19s-28.65-5.36-37.37-16.09c-8.72-10.73-13.08-26.19-13.08-46.4v-26.37c0-20.35,4.32-35.92,12.98-46.71C322.85,5.83,335.28.43,351.47.43s28.82,5.4,37.48,16.19c8.65,10.8,13.04,26.23,13.18,46.3v26.16c0,20.49-4.36,36.13-13.08,46.92ZM366.32,33.13c-3.11-5.61-8.07-8.41-14.85-8.41s-11.45,2.63-14.43,7.89c-2.98,5.26-4.54,13.43-4.67,24.5v35.92c0,12.04,1.56,20.9,4.67,26.58,3.11,5.68,7.99,8.51,14.64,8.51s11.35-2.7,14.53-8.1c3.18-5.4,4.78-13.91,4.78-25.54v-35.3c0-11.76-1.56-20.45-4.67-26.06Z"
        />
        <path
          fill="#28195a"
          d="M530.05,94.07h15.99v24.08h-15.99v31.97h-31.35v-31.97h-58.96l-1.66-18.69L498.49,2.92l31.56-.42v91.56ZM468.38,94.07h30.31v-50.87l-2.08,3.74-28.24,47.13Z"
        />
      </g>
      <g>
        <path
          fill="#28195a"
          d="M171.48,208.17v14.34h-6.76v-38.77h14.78c2.87,0,5.37.53,7.5,1.58,2.13,1.06,3.77,2.51,4.93,4.36,1.16,1.85,1.74,3.98,1.74,6.38s-.56,4.67-1.69,6.49c-1.13,1.82-2.76,3.21-4.91,4.17-2.15.96-4.71,1.44-7.69,1.44h-7.91ZM171.48,202.72h8.01c2.33,0,4.12-.56,5.37-1.69,1.25-1.13,1.88-2.76,1.88-4.91s-.63-3.79-1.88-5.04c-1.25-1.25-2.97-1.9-5.15-1.94h-8.23v13.58Z"
        />
        <path
          fill="#28195a"
          d="M215.1,219.67c-1.05,1.13-2.23,1.97-3.52,2.54-1.29.56-2.7.85-4.23.85-1.82,0-3.47-.37-4.96-1.12-1.49-.74-2.65-1.77-3.49-3.08-.84-1.31-1.25-2.76-1.25-4.36,0-3.05,1.14-5.41,3.41-7.06,2.27-1.65,5.53-2.46,9.79-2.43h3.98v-2.02c0-1.56-.42-2.77-1.25-3.63-.84-.85-2.07-1.28-3.71-1.28-1.02,0-1.9.16-2.64.49-.75.33-1.33.79-1.75,1.39-.42.6-.63,1.3-.63,2.1l-6.6-.05c0-1.56.52-3.03,1.55-4.39s2.46-2.44,4.28-3.24c1.82-.8,3.85-1.2,6.11-1.2,3.42,0,6.12.86,8.12,2.59,2,1.73,3.03,4.06,3.11,7.01v13.03c0,2.65.36,4.74,1.09,6.27v.44h-6.65c-.33-.65-.58-1.6-.76-2.84ZM212.38,216.92c1.13-.67,1.94-1.52,2.45-2.54v-5.4h-3.33c-2.44,0-4.26.41-5.48,1.23-1.22.82-1.83,2.04-1.83,3.68,0,1.24.41,2.22,1.23,2.94.82.73,1.9,1.09,3.24,1.09s2.58-.34,3.71-1.01Z"
        />
        <path
          fill="#28195a"
          d="M228.41,199.96c.98-2.2,2.34-3.88,4.06-5.04,1.73-1.16,3.72-1.74,5.97-1.74,1.67,0,3.15.29,4.44.87,1.29.58,2.39,1.44,3.3,2.56l.27-2.89h6v27.97c0,1.96-.44,3.87-1.31,5.73s-2.3,3.39-4.28,4.61c-1.98,1.22-4.52,1.83-7.61,1.83-2.11,0-4.15-.43-6.13-1.28-1.98-.85-3.48-1.99-4.5-3.41l3.05-3.93c.94,1.2,2.03,2.09,3.24,2.67,1.22.58,2.55.87,4.01.87,2.22,0,3.93-.61,5.13-1.83,1.2-1.22,1.8-2.97,1.8-5.26v-1.85c-.91,1.09-1.99,1.9-3.24,2.43s-2.66.79-4.23.79c-2.22,0-4.2-.61-5.94-1.83-1.74-1.22-3.1-2.96-4.06-5.23-.96-2.27-1.44-4.95-1.44-8.04v-.27c0-2.94.49-5.52,1.47-7.72ZM235.22,215.28c1.16,1.65,2.78,2.48,4.85,2.48,1.31,0,2.44-.28,3.41-.84.96-.56,1.75-1.39,2.37-2.48v-12.76c-1.24-2.14-3.14-3.22-5.73-3.22-2.11,0-3.74.84-4.91,2.54-1.16,1.69-1.75,4.17-1.75,7.44,0,2.91.58,5.19,1.75,6.84Z"
        />
        <path
          fill="#28195a"
          d="M264.45,221.31c-2.11-1.16-3.74-2.83-4.88-4.99-1.14-2.16-1.72-4.66-1.72-7.5v-.76c0-2.8.53-5.32,1.58-7.58,1.05-2.25,2.56-4.03,4.53-5.34,1.96-1.31,4.29-1.96,6.98-1.96s4.8.55,6.65,1.66c1.85,1.11,3.27,2.74,4.25,4.91.98,2.16,1.47,4.73,1.47,7.72v2.62h-18.87v.16c.14,1.49.55,2.82,1.23,3.98.67,1.16,1.56,2.06,2.67,2.7,1.11.64,2.37.95,3.79.95,1.53,0,2.89-.3,4.09-.9s2.25-1.48,3.16-2.64l3.38,3.33c-1.16,1.74-2.7,3.08-4.61,4.01-1.91.93-4.06,1.39-6.46,1.39-2.73,0-5.14-.58-7.25-1.74ZM267.88,199.17c-.87.55-1.6,1.35-2.18,2.4-.58,1.06-.96,2.33-1.15,3.82h12.27v-.49c-.04-1.34-.3-2.52-.79-3.52-.49-1-1.16-1.75-2.02-2.26-.85-.51-1.88-.76-3.08-.76s-2.18.27-3.05.82Z"
        />
        <path
          fill="#28195a"
          d="M308.77,193.72l.22,3.54c1.09-1.38,2.33-2.41,3.71-3.08,1.38-.67,2.96-1.01,4.74-1.01,3.05,0,5.33.87,6.84,2.62,1.51,1.74,2.28,4.38,2.32,7.91v18.81h-6.54v-18.7c-.04-1.89-.45-3.25-1.25-4.09-.8-.84-2.09-1.25-3.87-1.25-1.31,0-2.46.32-3.46.95-1,.64-1.77,1.52-2.32,2.64v20.45h-6.54v-28.79h6.16Z"
        />
        <path
          fill="#28195a"
          d="M333.31,200.45c1.05-2.24,2.6-4.01,4.63-5.32,2.04-1.31,4.45-1.96,7.25-1.96s5.05.61,7.09,1.83c2.04,1.22,3.61,2.94,4.72,5.18,1.11,2.24,1.66,4.86,1.66,7.88v.38c0,2.91-.56,5.46-1.69,7.66-1.13,2.2-2.71,3.91-4.74,5.12-2.04,1.22-4.36,1.83-6.98,1.83s-4.93-.59-6.95-1.77c-2.02-1.18-3.59-2.86-4.72-5.04-1.13-2.18-1.71-4.71-1.74-7.58l-.05-.82c-.04-2.69.47-5.15,1.53-7.39ZM339.2,213.49c.55,1.4,1.34,2.48,2.4,3.24,1.05.76,2.27,1.14,3.65,1.14s2.64-.37,3.65-1.12c1.02-.74,1.81-1.82,2.37-3.22.56-1.4.85-3.08.85-5.04v-.65c0-1.96-.27-3.65-.82-5.07s-1.34-2.51-2.37-3.27c-1.04-.76-2.28-1.15-3.74-1.15-1.34,0-2.52.35-3.52,1.06-1,.71-1.78,1.75-2.34,3.13-.56,1.38-.88,3.02-.95,4.91v.98c0,1.96.27,3.64.82,5.04Z"
        />
        <path
          fill="#28195a"
          d="M372.19,186.63v7.09h5.12v4.8h-5.12v15.98c0,1.16.23,1.99.68,2.48.45.49,1.24.74,2.37.74.73,0,1.49-.07,2.29-.22v4.96c-1.38.4-2.82.6-4.31.6-2.51,0-4.41-.68-5.7-2.04-1.29-1.36-1.92-3.41-1.88-6.13v-16.36h-4.63v-4.8h4.63v-7.09h6.54Z"
        />
        <path
          fill="#28195a"
          d="M398.96,222.51v-23.99h-4.42v-4.8h4.42v-2.73c0-3.16.88-5.61,2.64-7.33,1.76-1.73,4.24-2.59,7.44-2.59,1.13,0,2.36.16,3.71.49l-.11,5.02c-.65-.14-1.49-.22-2.51-.22-1.49,0-2.64.39-3.43,1.17-.8.78-1.2,1.94-1.2,3.46v2.73h5.94v4.8h-5.94v23.99h-6.54Z"
        />
        <path
          fill="#28195a"
          d="M416.19,200.45c1.05-2.24,2.6-4.01,4.63-5.32,2.04-1.31,4.45-1.96,7.25-1.96s5.05.61,7.09,1.83c2.04,1.22,3.61,2.94,4.72,5.18,1.11,2.24,1.66,4.86,1.66,7.88v.38c0,2.91-.56,5.46-1.69,7.66-1.13,2.2-2.71,3.91-4.74,5.12-2.04,1.22-4.36,1.83-6.98,1.83s-4.93-.59-6.95-1.77c-2.02-1.18-3.59-2.86-4.72-5.04-1.13-2.18-1.71-4.71-1.74-7.58l-.05-.82c-.04-2.69.47-5.15,1.53-7.39ZM422.08,213.49c.55,1.4,1.34,2.48,2.4,3.24,1.05.76,2.27,1.14,3.65,1.14s2.64-.37,3.65-1.12c1.02-.74,1.81-1.82,2.37-3.22.56-1.4.85-3.08.85-5.04v-.65c0-1.96-.27-3.65-.82-5.07s-1.34-2.51-2.37-3.27c-1.04-.76-2.28-1.15-3.74-1.15-1.34,0-2.52.35-3.52,1.06-1,.71-1.78,1.75-2.34,3.13-.56,1.38-.88,3.02-.95,4.91v.98c0,1.96.27,3.64.82,5.04Z"
        />
        <path
          fill="#28195a"
          d="M464.55,222.51l-.16-2.94c-.95,1.16-2.1,2.04-3.46,2.62-1.36.58-2.92.87-4.66.87-3.13,0-5.5-.9-7.12-2.7-1.62-1.8-2.45-4.44-2.48-7.93v-18.7h6.6v18.65c.04,1.82.44,3.17,1.2,4.06.76.89,1.91,1.34,3.44,1.34s2.82-.29,3.87-.87c1.05-.58,1.84-1.42,2.34-2.51v-20.66h6.6v28.79h-6.16Z"
        />
        <path
          fill="#28195a"
          d="M483.25,193.72l.22,3.54c1.09-1.38,2.33-2.41,3.71-3.08,1.38-.67,2.96-1.01,4.74-1.01,3.05,0,5.33.87,6.84,2.62,1.51,1.74,2.28,4.38,2.32,7.91v18.81h-6.54v-18.7c-.04-1.89-.45-3.25-1.25-4.09-.8-.84-2.09-1.25-3.87-1.25-1.31,0-2.46.32-3.46.95-1,.64-1.77,1.52-2.32,2.64v20.45h-6.54v-28.79h6.16Z"
        />
        <path
          fill="#28195a"
          d="M507.76,200.07c.93-2.2,2.24-3.9,3.95-5.1,1.71-1.2,3.71-1.8,6-1.8,1.53,0,2.9.27,4.12.82,1.22.55,2.3,1.38,3.24,2.51v-14.88h6.54v40.89h-5.89l-.38-3.11c-.95,1.24-2.05,2.15-3.33,2.75-1.27.6-2.73.9-4.36.9-2.25,0-4.23-.62-5.92-1.85-1.69-1.24-3.01-3-3.95-5.29-.95-2.29-1.42-4.98-1.42-8.07s.46-5.57,1.39-7.77ZM512.91,208.44c0,3.02.55,5.33,1.66,6.92,1.11,1.6,2.66,2.4,4.66,2.4,1.38,0,2.55-.3,3.52-.9.96-.6,1.74-1.48,2.32-2.64v-12.27c-1.2-2.33-3.13-3.49-5.78-3.49-1.96,0-3.5.75-4.61,2.26-1.11,1.51-1.7,3.7-1.77,6.57v1.14Z"
        />
      </g>
    </g>
    <g>
      <path
        opacity=".3"
        fill="#939598"
        d="M700.7,178.42c-14.39.94-28.73,2.47-43,4.6-11.51,1.72-23.09,3.65-34.42,6.36-7.24,1.73-14.67,4.53-20.45,9.41-5.13,4.33-8.42,10.64-6.87,17.52,1.87,8.36,10.16,11.76,13.62,18.99,4.24,8.87-.86,19.32-7.18,25.63-6.92,6.91-16.09,11.15-25.18,14.26-21.26,7.27-43.86,9.24-66.12,10.63-23.06,1.45-46.19,1.69-69.29,1.17-46.06-1.03-91.98-5.08-137.92-8.41-64-4.64-128.49-6.84-192.62-3.51-24.22,1.26-49.56,2.56-73.01,9.36-13.33,3.87-34.08,14.61-28.98,32.04,2.3,7.85,9.01,13.63,15.28,18.27,3.57,2.64,7.32,5.02,11.17,7.23l11.17-5.39c-.53-.28-1.07-.55-1.6-.84-8.01-4.28-16.48-9.02-22.65-15.89-3.91-4.36-5.72-8.75-2.38-13.48,4.17-5.93,11.55-9.34,18.19-11.48,22.03-7.06,46.18-8.25,69.08-9.54,59.94-3.39,120.41-1.88,180.28,2.18,44.8,3.03,89.53,7.16,134.4,8.93,43.59,1.72,88.5,2.33,131.66-5.1,18.07-3.11,37.67-8.2,52.14-20.23,12-9.98,20.53-28.71,10.75-43.24-3.41-5.06-14.51-11.41-10.27-18.49,3.7-6.18,12.96-8.77,19.4-10.31,21.56-5.16,43.64-6.35,65.3-10.88,4.71-.98,18.21-3.69,21.19-3.89l-11.71-5.92Z"
      />
      <path
        fill="#28195a"
        d="M122.69,366.46c-17.36-8.96-36.49-14.73-54.57-22.03-10.62-4.29-21.17-8.82-31.31-14.15-8.01-4.21-16.48-8.88-22.65-15.65-3.91-4.29-5.72-8.61-2.38-13.28,4.17-5.84,11.55-9.2,18.19-11.3,22.03-6.96,46.18-8.12,69.08-9.4,59.94-3.34,120.41-1.85,180.28,2.14,44.8,2.99,89.53,7.05,134.4,8.79,43.59,1.69,88.5,2.29,131.66-5.02,18.07-3.06,37.67-8.08,52.14-19.93,12-9.83,20.53-28.28,10.75-42.58-3.41-4.98-14.51-11.23-10.27-18.21,3.7-6.08,12.96-8.64,19.4-10.16,21.56-5.08,43.82-8.03,65.87-9.83,10.92-.89,21.86-1.41,32.81-1.61,6.38-.12,6.4-10.04,0-9.92-22.4.42-44.73,2.28-66.9,5.53-11.51,1.69-23.09,3.6-34.42,6.26-7.24,1.71-14.67,4.46-20.45,9.27-5.13,4.27-8.42,10.48-6.87,17.26,1.87,8.24,10.16,11.58,13.62,18.71,4.24,8.74-.86,19.03-7.18,25.24-6.92,6.81-16.09,10.98-25.18,14.04-21.26,7.16-43.86,9.1-66.12,10.47-23.06,1.42-46.19,1.66-69.29,1.15-46.06-1.02-91.98-5-137.92-8.28-64-4.57-128.49-6.73-192.62-3.46-24.22,1.24-49.56,2.52-73.01,9.22-13.33,3.81-34.08,14.39-28.98,31.56,2.3,7.73,9.01,13.42,15.28,17.99,8.84,6.44,18.79,11.35,28.7,15.88,20.67,9.44,42.2,16.73,63.17,25.42,3.29,1.36,6.57,2.8,9.74,4.43,5.67,2.92,10.69-5.64,5.01-8.57h0Z"
      />
      <path
        opacity=".3"
        fill="#939598"
        d="M610.41,627.57l-17.67,28.46c-.42.68-1.04,1.2-1.77,1.51l-154.91,64.37c-1.03.43-2.19.38-3.18-.12l-336.82-170.02c-3.23-1.63-2.58-6.42.97-7.13l179.19-35.92c.66-.13,1.34-.09,1.98.13l330.2,113.12c2.31.79,3.29,3.53,2,5.61Z"
      />
      <g>
        <polygon
          fill="#939598"
          points="127.03 361.4 100.2 370.75 136.09 411.77 186.63 392.72 127.03 361.4"
        />
        <polygon
          fill="#58595b"
          points="100.2 370.75 101.73 396.86 136.47 432.84 136.09 411.77 100.2 370.75"
        />
        <polygon
          fill="#d1d3d4"
          points="136.09 411.77 186.63 392.72 187.04 415.12 136.47 432.84 136.09 411.77"
        />
        <g>
          <polygon
            fill="#fff"
            strokeWidth=".94px"
            stroke="#231f20"
            strokeLinejoin="round"
            points="175.65 404.69 193.82 412.93 162.83 425.21 147.37 415.45 175.65 404.69"
          />
          <polygon
            fill="#fff"
            strokeWidth=".94px"
            stroke="#231f20"
            strokeLinejoin="round"
            points="147.37 415.45 147.37 425.79 162.03 436.55 162.83 425.21 147.37 415.45"
          />
        </g>
        <polyline
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          points="104.53 398.95 103.25 374.22 132.34 364.66"
        />
        <polyline
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          points="110.36 405.03 109.08 380.31 141.57 369.63"
        />
        <polyline
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          points="116.28 410.95 115.72 388.41 150.96 374.41"
        />
        <line
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          x1="120.43"
          y1="393.87"
          x2="136.4"
          y2="411.77"
        />
        <polygon
          fill="#fff"
          points="158.19 378.7 120.63 393.79 136.03 411.01 185.74 392.49 158.19 378.7"
        />
        <polygon
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          points="162.83 425.21 162.03 436.55 193.06 423.93 193.82 412.93 162.83 425.21"
        />
        <polygon
          fill="none"
          stroke="#231f20"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth=".94px"
          points="158.24 378.55 186.63 392.72 136.51 411.27 136.47 432.84 120.23 416.01 120.43 393.87 158.24 378.55"
        />
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                fill="#4c5b8c"
                d="M159.55,459.46l-34.32-21.84c-6.26-3.98-6.06-11.51.37-14.06l86.89-34.43c2.81-1.11,6.25-.99,9.27.34l58.81,25.8-121.02,44.19Z"
              />
              <path
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="1.06px"
                fill="none"
                d="M159.55,459.46l-34.32-21.84c-6.26-3.98-6.06-11.51.37-14.06l86.89-34.43c2.81-1.11,6.25-.99,9.27.34l58.81,25.8-121.02,44.19Z"
              />
            </g>
            <polygon
              fill="#394463"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              points="121.36 434.4 128.69 470.36 159.55 459.46 121.36 434.4"
            />
          </g>
          <path
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1.06px"
            fill="#e6971f"
            d="M458.86,643.67c-1.78.65-2.96,2.31-2.96,4.18l-7.07,49.68,160.9-64.15c1.8-.6,3.03-2.23,3.08-4.1l2.28-46.72-156.23,61.1Z"
          />
          <g>
            <path
              fill="#f6c246"
              d="M129,466.23l170.89-61.81c.35-.12.73-.09,1.06.09l311.44,173.97c3.98,2.22,3.53,8.09-.75,9.68l-151.94,56.39c-.35.13-.74.1-1.07-.08l-329.63-178.24Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M129,466.23l170.89-61.81c.35-.12.73-.09,1.06.09l311.44,173.97c3.98,2.22,3.53,8.09-.75,9.68l-151.94,56.39c-.35.13-.74.1-1.07-.08l-329.63-178.24Z"
            />
          </g>
          <g>
            <path
              fill="#4c5b8c"
              d="M170.96,462.95l127.22-44.04c1.83-.63,3.83-.45,5.52.5l251.62,141.6c5.06,2.85,4.48,10.35-.95,12.38l-118.8,44.42c-1.84.69-3.88.54-5.6-.4l-260.04-141.98c-5.2-2.84-4.56-10.55,1.03-12.48Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M170.96,462.95l127.22-44.04c1.83-.63,3.83-.45,5.52.5l251.62,141.6c5.06,2.85,4.48,10.35-.95,12.38l-118.8,44.42c-1.84.69-3.88.54-5.6-.4l-260.04-141.98c-5.2-2.84-4.56-10.55,1.03-12.48Z"
            />
          </g>
          <path
            fill="#fff"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1.06px"
            d="M295.11,430.89l-98.54,36.45c-3.24,1.2-3.55,5.64-.51,7.28l128.02,68.91c1.02.55,2.22.63,3.31.23l99.95-36.97c3.25-1.2,3.55-5.67.48-7.29l-129.43-68.39c-1.01-.53-2.21-.61-3.28-.22Z"
          />
          <g>
            <path
              fill="#e6971f"
              d="M118.42,475.37l7.55,60.95c0,.96.54,1.84,1.39,2.28l306.74,158.45c11.43,5.91,25.06-2.39,25.06-15.26v-35.51c0-.94-.52-1.81-1.34-2.25l-328.06-177.79c-1.71-.93-11.34,7.2-11.34,9.14Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M118.42,475.37l7.55,60.95c0,.96.54,1.84,1.39,2.28l306.74,158.45c11.43,5.91,25.06-2.39,25.06-15.26v-35.51c0-.94-.52-1.81-1.34-2.25l-328.06-177.79c-1.71-.93-11.34,7.2-11.34,9.14Z"
            />
          </g>
          <ellipse fill="#0d1f42" cx="470.3" cy="575.38" rx="12.26" ry="5.38" />
          <ellipse fill="#be1e2d" cx="470.3" cy="575.34" rx="9.65" ry="4.66" />
          <path
            fill="#fff"
            d="M470.3,578.65c-3.83,0-6.83-1.56-6.83-3.56s3-3.56,6.83-3.56,6.83,1.57,6.83,3.56-3,3.56-6.83,3.56ZM470.3,572.01c-3.51,0-6.47,1.41-6.47,3.08s2.96,3.08,6.47,3.08,6.47-1.41,6.47-3.08-2.96-3.08-6.47-3.08Z"
          />
          <polygon
            fill="#fff"
            points="466.59 574.2 467.85 573.67 473.93 575.62 473.1 576.14 466.59 574.2"
          />
          <g>
            <path
              fill="#0d1f42"
              d="M484.78,534.95l-17.6-8.62c-.87-.42-1.88-.48-2.78-.17l-37.75,13.43c-1.14.41-1.89,1.31-2.01,2.42-.12,1.11.42,2.16,1.44,2.81l15.33,9.79c.52.33,1.12.52,1.73.56.48.03.97-.04,1.43-.21l40.03-14.6c1.19-.43,1.95-1.43,1.99-2.6s-.65-2.25-1.8-2.82Z"
            />
            <path
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              d="M481.53,535.58l-15.64-7.66c-.77-.38-1.67-.43-2.47-.15l-33.54,11.93c-1.01.36-1.68,1.16-1.78,2.15-.11.99.37,1.92,1.28,2.5l13.62,8.7c.46.3.99.46,1.53.5.43.03.86-.04,1.27-.18l35.56-12.98c1.05-.38,1.73-1.27,1.77-2.31.04-1.04-.58-2-1.6-2.5Z"
            />
            <g>
              <path
                fill="#4c5b8c"
                d="M448.27,539.3l-2.22.88,5.89,3.57-.9.36-5.89-3.57-2.21.88-.72-.43,5.32-2.11.72.43Z"
              />
              <path
                fill="#4c5b8c"
                d="M455.29,542.22c-.55.02-1.11-.04-1.67-.18-.56-.14-1.09-.36-1.57-.65l-.15-.09c-.45-.27-.78-.56-.98-.87s-.25-.59-.15-.87c.11-.28.39-.5.84-.68.66-.26,1.39-.34,2.19-.23.8.11,1.58.4,2.35.87l.35.21-3.46,1.38.03.02c.48.28,1.02.45,1.59.52.58.07,1.08.01,1.51-.16.55-.22.79-.53.69-.94l.93.03c.2.55-.13,1-.98,1.34-.46.18-.97.29-1.53.31ZM454.92,539.65l-.06-.03c-.45-.25-.9-.4-1.35-.46-.45-.06-.86-.01-1.22.13s-.53.33-.52.58c0,.24.21.51.6.8l2.55-1.02Z"
              />
              <path
                fill="#4c5b8c"
                d="M460.61,538.47c-.3,0-.72.05-1.25.17-.76.17-1.4.25-1.92.23-.52-.02-.95-.14-1.31-.35-.27-.16-.43-.34-.49-.54-.06-.2,0-.39.16-.58.16-.19.43-.36.79-.5.38-.15.78-.25,1.21-.28.42-.04.83-.02,1.23.06s.74.2,1.04.38l-.87.35c-.23-.14-.53-.22-.9-.24s-.71.03-1.02.15c-.32.13-.51.27-.55.42s.04.29.26.43c.16.1.35.15.57.17s.42,0,.61-.03c.19-.03.43-.08.73-.14.77-.17,1.42-.25,1.95-.23.52.02.98.15,1.38.39.29.17.46.36.51.56s0,.39-.19.59c-.18.19-.46.36-.84.52-.42.17-.86.27-1.33.3s-.91.01-1.33-.07c-.42-.08-.77-.21-1.05-.38l.88-.35c.3.17.64.26,1.02.27.38.01.76-.05,1.12-.2.33-.13.53-.27.6-.43.07-.16,0-.3-.22-.43-.23-.14-.49-.21-.79-.22Z"
              />
              <path
                fill="#4c5b8c"
                d="M459.81,534.51l1.19.72.96-.38.65.39-.96.38,3.04,1.84c.2.12.4.2.58.22.18.02.37,0,.57-.08.1-.04.22-.11.36-.2l.68.41c-.16.12-.35.23-.57.32-.39.15-.79.2-1.21.15-.42-.06-.85-.21-1.28-.47l-3.04-1.84-.94.37-.65-.39.94-.37-1.19-.72.87-.35Z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#0d1f42"
              d="M429.1,554.67l-17.6-8.62c-.87-.42-1.88-.48-2.78-.17l-37.75,13.43c-1.14.41-1.89,1.31-2.01,2.42-.12,1.11.42,2.16,1.44,2.81l15.33,9.79c.52.33,1.12.52,1.73.56.48.03.97-.04,1.43-.21l40.03-14.6c1.19-.43,1.95-1.43,1.99-2.6s-.65-2.25-1.8-2.82Z"
            />
            <g>
              <path
                fill="#4c5b8c"
                d="M425.85,555.31l-15.64-7.66c-.77-.38-1.67-.43-2.47-.15l-33.54,11.93c-1.01.36-1.68,1.16-1.78,2.15-.11.99.37,1.92,1.28,2.5l13.62,8.7c.46.3.99.46,1.53.5.43.03.86-.04,1.27-.18l35.56-12.98c1.05-.38,1.73-1.27,1.77-2.31s-.58-2-1.6-2.5Z"
              />
              <path
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="1.06px"
                fill="none"
                d="M425.85,555.31l-15.64-7.66c-.77-.38-1.67-.43-2.47-.15l-33.54,11.93c-1.01.36-1.68,1.16-1.78,2.15-.11.99.37,1.92,1.28,2.5l13.62,8.7c.46.3.99.46,1.53.5.43.03.86-.04,1.27-.18l35.56-12.98c1.05-.38,1.73-1.27,1.77-2.31s-.58-2-1.6-2.5Z"
              />
            </g>
            <g>
              <path
                fill="#fff"
                d="M397.67,564.13l-.82.3-3.58-2.2-3.15,1.14,3.58,2.2-.82.29-7.74-4.75.82-.29,3.33,2.04,3.15-1.14-3.33-2.04.82-.3,7.74,4.75Z"
              />
              <path
                fill="#fff"
                d="M394.62,560.91c-.27-.34-.38-.64-.31-.91s.31-.48.73-.64.91-.21,1.48-.17c.57.03,1.16.16,1.79.37.62.21,1.23.5,1.83.86l.08.05c.58.36,1,.7,1.26,1.04.26.34.35.64.27.9-.08.26-.31.47-.72.62s-.91.21-1.47.17c-.57-.04-1.16-.16-1.79-.37-.63-.21-1.24-.5-1.83-.86l-.07-.04c-.55-.34-.96-.68-1.24-1.01ZM398.67,562.52c.63.15,1.14.15,1.54,0s.53-.37.39-.69c-.14-.32-.55-.68-1.21-1.1l-.09-.05c-.63-.39-1.26-.66-1.89-.81-.64-.15-1.15-.16-1.56-.01s-.51.37-.37.69.54.69,1.22,1.11l.09.05c.63.39,1.26.67,1.89.81Z"
              />
              <path
                fill="#fff"
                d="M399,558.04l.66.38c-.15-.43.06-.74.64-.95.64-.23,1.39-.2,2.24.09-.13-.24-.15-.45-.06-.64.09-.19.29-.34.62-.46.51-.18,1.06-.22,1.66-.11s1.23.37,1.9.78l3.86,2.37-.8.29-3.8-2.33c-.42-.26-.81-.42-1.15-.49-.35-.07-.7-.03-1.06.1-.27.1-.4.23-.4.41-.01.22.17.45.53.71l3.82,2.34-.79.29-3.77-2.31c-.83-.51-1.58-.65-2.24-.41-.27.1-.42.22-.45.36-.04.15.02.33.2.52l4.2,2.58-.79.29-5.75-3.53.75-.27Z"
              />
              <path
                fill="#fff"
                d="M412.27,558.61c-.55-.03-1.13-.14-1.74-.34-.61-.2-1.19-.47-1.76-.82l-.17-.11c-.53-.33-.94-.66-1.22-.99s-.41-.64-.38-.92c.03-.28.26-.49.67-.64.6-.22,1.32-.23,2.15-.05s1.7.55,2.61,1.11l.41.25-3.14,1.14.03.02c.56.33,1.15.56,1.75.68s1.1.11,1.48-.03c.5-.18.65-.49.45-.92l.95.11c.35.6.14,1.03-.64,1.31-.42.15-.91.22-1.46.19ZM411.22,555.9l-.07-.04c-.52-.3-1.02-.5-1.49-.6-.47-.1-.87-.09-1.2.03s-.45.3-.37.56c.07.26.34.55.81.88l2.32-.84Z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#35220a"
              d="M444.48,675.17h0c1.32.38,2.38-.37,2.38-1.69v-9.31c0-1.32-1.07-2.69-2.38-3.08h0c-1.32-.38-2.38.37-2.38,1.69v9.31c0,1.32,1.07,2.69,2.38,3.08Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M444.48,675.17h0c1.32.38,2.38-.37,2.38-1.69v-9.31c0-1.32-1.07-2.69-2.38-3.08h0c-1.32-.38-2.38.37-2.38,1.69v9.31c0,1.32,1.07,2.69,2.38,3.08Z"
            />
          </g>
          <g>
            <path
              fill="#35220a"
              d="M471.11,673.63h0c1.25-.18,2.26-1.35,2.26-2.6v-8.85c0-1.25-1.01-2.12-2.26-1.93h0c-1.25.18-2.26,1.35-2.26,2.6v8.85c0,1.25,1.01,2.12,2.26,1.93Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M471.11,673.63h0c1.25-.18,2.26-1.35,2.26-2.6v-8.85c0-1.25-1.01-2.12-2.26-1.93h0c-1.25.18-2.26,1.35-2.26,2.6v8.85c0,1.25,1.01,2.12,2.26,1.93Z"
            />
          </g>
          <g opacity=".5">
            <polygon
              fill="#bf791b"
              points="458.23 685.66 123.9 509.88 123.75 508.65 458.33 684.5 458.23 685.66"
            />
          </g>
          <g>
            <path
              fill="#4c5b8c"
              d="M324.95,596.78l60.87,31.37c.68.34,1.09,1.05,1.03,1.81l-.51,22.25c-.02.77-.84,1.26-1.52.91l-61.48-31.37c-.34-.17-.56-.52-.57-.91l-.54-22.38c0-1.4,1.47-2.31,2.72-1.68Z"
            />
            <path
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.06px"
              fill="none"
              d="M324.95,596.78l60.87,31.37c.68.34,1.09,1.05,1.03,1.81l-.51,22.25c-.02.77-.84,1.26-1.52.91l-61.48-31.37c-.34-.17-.56-.52-.57-.91l-.54-22.38c0-1.4,1.47-2.31,2.72-1.68Z"
            />
          </g>
          <path
            fill="#0d1f42"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1.06px"
            d="M329.38,604.09l22.99,10.91c.31.15.5.45.5.79v14.49c0,.64-.66,1.06-1.24.8l-22.99-10.37c-.32-.14-.52-.46-.52-.8v-15.03c0-.65.67-1.07,1.26-.79Z"
          />
          <path
            fill="#0d1f42"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1.06px"
            d="M377.56,636.25c-.06,3.21-3.28,4.21-7.18,2.22-3.91-1.99-7.03-6.21-6.97-9.43.06-3.21,3.28-4.21,7.18-2.22,3.91,1.99,7.03,6.21,6.97,9.43Z"
          />
          <path d="M375.07,634.99c-.04,2.09-2.13,2.73-4.66,1.44-2.53-1.29-4.56-4.03-4.52-6.11s2.13-2.73,4.66-1.44,4.56,4.03,4.52,6.11Z" />
          <g>
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M288.67,454.12c.95-.35,1.9-.7,2.85-1.05.44-.12.81-.1,1.1.08.03.02.05.03.08.05,4.14,2.45,8.29,4.89,12.43,7.34.3.22.19.38-.13.51-.94.35-1.89.7-2.83,1.04-.36.12-.73.11-1.1-.06-4.17-2.46-8.34-4.93-12.51-7.39-.25-.18-.22-.35.12-.51Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M295.86,451.47c1.04-.38,2.08-.77,3.12-1.15.22-.08.48-.09.74-.06l13.64,2.47c-2.52-1.49-5.04-2.98-7.56-4.47-.25-.16-.22-.33.11-.5l2.79-1.03.06-.02c.4-.12.77-.1,1.1.06.02,0,.03.02.05.03,4.15,2.45,8.31,4.91,12.46,7.36.24.19.21.36-.12.51l-.07.03c-1,.37-2.01.74-3.01,1.11-.25.08-.51.1-.76.06l-14.05-2.69c2.65,1.56,5.29,3.13,7.94,4.69.25.21.18.37-.11.51l-2.86,1.05c-.45.12-.82.09-1.1-.07-4.17-2.46-8.34-4.93-12.51-7.39-.28-.18-.23-.35.14-.51Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M287.55,461.96c2.43-.91,5.79.96,3.16,1.96l-3.13,1.16-3.26-1.92,3.23-1.19h0ZM282.2,461.9l-3.15-1.86,2.73-1.01c1.31-.49,2.74-.28,3.54.18.73.42.94,1.05-.07,1.56l-3.06,1.13h0ZM273.01,460.37c4.17,2.46,8.34,4.93,12.51,7.39.35.18.72.18,1.09.06l2.03-.75,1.41-.52,3.13-1.16c2.26-.83,3.87-2.02,3.42-3.16-.55-1.4-3.67-2.85-7-2.11,1.1-.93.95-1.88-1.34-2.94-2.03-.94-5.3-.83-8.97.4l-2.73,1.01-1.41.52-2.05.76c-.33.17-.35.35-.09.51Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M274.96,466.8c.91-.92,1.25-2.02-.6-3.17-2.35-1.46-5.64-1.98-10.42-.39l-2.96,1.09-1.5.55-1.95.72c-.33.16-.38.33-.11.52,4.17,2.46,8.34,4.92,12.5,7.39.36.17.72.18,1.09.07.94-.35,1.88-.69,2.81-1.04.01,0,.02,0,.03-.01.33-.13.4-.3.14-.51-1.44-.85-2.88-1.7-4.31-2.55l2.2-.81,7.32,1.62c.29.07.56.05.83-.03,1-.37,2-.74,3-1.1.02,0,.04-.01.06-.02.32-.15.37-.33-.01-.55-2.69-.59-5.37-1.19-8.06-1.78l-.05.02h0ZM263.48,465.8l2.96-1.09c2.59-.96,5.92,1.08,4.11,2.03l-3.37,1.24-3.69-2.18Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M253.54,475.2l3.73-1.37-6.73-2.19,3,3.56h0ZM251.99,480.04c-2.27-3.15-4.54-6.29-6.81-9.44l-.08-.11c-.09-.16-.01-.29.24-.4l.2-.07,2.77-1.02.2-.07c.3-.09.6-.1.93,0,6.08,1.77,12.17,3.55,18.25,5.32.41.22.36.41-.04.57-1.01.37-2.01.74-3.02,1.11-.34.09-.68.1-1.03-.03-.98-.32-1.95-.63-2.93-.95l-5.62,2.07,1.36,1.62c.1.19,0,.33-.26.42-1,.37-2,.74-3,1.1-.43.14-.82.11-1.17-.1Z"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M238.56,481.96l.15.09,3.25,1.92h.02c.39.24-.35.51-.73.28l-3.28-1.94-.15-.09.73-.27Z"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M237.33,482.43l.13.07c1.13.67,2.16,1.27,3.29,1.94.16.12.11.22-.08.31,0,0-.01,0-.02,0l-.08.03h-.02c-.26.08-.48.07-.68-.05,0,0-.02-.01-.03-.02-.97-.7-1.88-1.34-2.95-2.02l-.1-.07.56-.21Z"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M236.27,482.81l.09.05c1.15.73,2.09,1.39,3.01,2.08,0,0,.02.02.03.02.11.11.06.21-.12.29-.01,0-.02,0-.03.01-.32.12-.65.24-.97.36-.35.08-.6.03-.76-.13,0,0,0-.01-.01-.02-.49-.82-1.06-1.55-1.93-2.3l-.1-.09.8-.29Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M242.64,480.49l.08.05c1.52.9,1.58.94,3.11,1.83.29.18.22.35-.1.52l-2.45.9-.06.02c-.4.11-.76.09-1.09-.05-.02,0-.04-.02-.05-.03l-3.17-1.87,3.75-1.37Z"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="241.15 479.58 241.48 479.46 242.75 480.21 242.41 480.33 241.15 479.58 241.15 479.58"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M231.27,483.24l.33-.12,1.24.73-.33.12c-.75.14-1.49.28-2.24.41-.32,0-.44-.08-.36-.22l1.36-.93h0Z"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="231.89 483.01 232.22 482.89 233.47 483.62 233.13 483.74 231.89 483.01 231.89 483.01"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="235.22 481.78 235.55 481.66 236.79 482.39 236.46 482.52 235.22 481.78 235.22 481.78"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="234.37 482.1 234.7 481.97 235.94 482.71 235.61 482.83 234.37 482.1 234.37 482.1"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M233.94,482.21l1.3.77c.08.05.1.11.05.17l-.61.4c-.31.2-.59.21-.97-.01l-1.24-.73c-.39-.23-.19-.35.25-.44.32-.07.63-.13.95-.2.11-.01.2,0,.29.05ZM233.41,482.53l-.5.18,1.11.65.5-.18-.21-.13-.35.13-.68-.41.35-.13-.21-.12Z"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="236.07 481.47 236.4 481.35 237.64 482.08 237.31 482.2 236.07 481.47 236.07 481.47"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="236.91 481.16 237.25 481.03 238.49 481.77 238.16 481.89 236.91 481.16 236.91 481.16"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="237.76 480.84 238.1 480.72 239.34 481.46 239.01 481.58 237.76 480.84 237.76 480.84"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="238.61 480.53 238.95 480.41 240.19 481.14 239.86 481.27 238.61 480.53 238.61 480.53"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="239.45 480.21 239.78 480.09 241.05 480.83 240.71 480.96 239.45 480.21 239.45 480.21"
            />
            <polygon
              fillRule="evenodd"
              fill="#28195a"
              points="240.3 479.9 240.63 479.77 241.9 480.52 241.56 480.64 240.3 479.9 240.3 479.9"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M228.83,476.21l7.94,4.69.08.05-.73.27-.09-.05-7.93-4.68c-.4-.23.33-.5.73-.27Z"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M226.79,476.68h.04s.07-.04.07-.04h.04c.24-.08.45-.07.64.02.01,0,.03.02.05.03,2.66,1.57,5.2,3.07,7.86,4.64l.13.08-.51.19-.13-.08c-2.54-1.55-5.2-3.01-8.19-4.5-.01,0-.03-.01-.04-.02-.17-.12-.14-.22.06-.32Z"
            />
            <path
              fill={resolveColor(svgColor)}
              fillRule="evenodd"
              d="M224.52,477.52s.02,0,.03-.01c.33-.12.71-.26,1.02-.38h.03c.19-.07.39-.06.6.01,0,0,.01,0,.02,0,3.19,1.63,5.86,3.09,8.22,4.52l.16.1-.62.23-.13-.09c-2.27-1.53-5.21-2.85-9.22-4.03-.01,0-.03,0-.04-.01-.3-.09-.29-.26-.05-.36Z"
            />
            <path
              fillRule="evenodd"
              fill="#28195a"
              d="M229.49,475.69s.03-.01.05-.02c2.8-1.03,7.19-2.65,9.68-3.57.36-.09.7-.07,1,.07.52.31,1.03.61,1.55.92.25.2.18.37-.12.51l-6.57,2.42,3.13,1.85c1.99-.73,3.99-1.47,5.98-2.2.38-.11.75-.11,1.11.06.5.3,1.01.6,1.51.89.26.2.19.37-.13.51l-5.98,2.21.2.12-3.71,1.39-.08-.05c-2.57-1.52-5.14-3.04-7.72-4.56-.3-.19-.26-.37.12-.55Z"
            />
            <path
              fill="#28195a"
              d="M257.66,481.1l-.51.19,1.19,1.25.21.2-.37-.16-2.19-.86-.6.22,3.55,1.34.59-.22-1.12-1.22-.18-.17.32.12,2.28.8.59-.22-1.97-1.92-.6.22,1.28,1.19.25.21-.37-.14-2.32-.83Z"
            />
            <path
              fill="#28195a"
              d="M261.32,480.66l-1.1-.65-.58.21,2.91,1.72.58-.21-1.46-.86c-.03-.06-.02-.12.02-.18s.12-.11.24-.15c.15-.06.3-.08.43-.07.13.01.27.05.4.13l1.33.78.58-.21-1.33-.79c-.51-.3-1.04-.34-1.58-.14-.29.11-.44.25-.44.43Z"
            />
            <path
              fill="#28195a"
              d="M266.4,480.56c.21-.08.36-.17.47-.27.1-.1.14-.21.12-.32l-.54-.03c0,.16-.13.29-.39.38-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31s-.09.24-.02.37c.07.13.2.25.4.37l.06.04c.2.12.43.21.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM264.51,480.05c-.14-.1-.2-.2-.19-.28.01-.09.09-.16.25-.22.16-.06.32-.08.5-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M267.54,478.54l-.43-.26c-.07,0-.14.03-.23.06-.26.09-.36.22-.3.39l-.27-.14-.55.2,2.05,1.21.58-.21-1.39-.82c-.08-.13.01-.25.29-.35.1-.04.19-.06.25-.08Z"
            />
            <path
              fill="#28195a"
              d="M270.64,479c.21-.08.36-.17.47-.27.1-.1.14-.21.13-.32l-.54-.03c0,.16-.13.29-.39.38-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.21.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM268.75,478.49c-.14-.1-.2-.2-.19-.28s.09-.16.25-.22c.16-.06.32-.08.5-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M274.96,476.51l-.6.22c.17.13.24.24.2.33-.04.1-.17.18-.4.27-.26.09-.53.12-.82.08-.29-.04-.58-.15-.88-.33l-.24-.14c-.3-.18-.45-.33-.47-.48-.02-.14.1-.26.36-.36.23-.08.44-.12.65-.11.21.01.42.07.64.18l.6-.22c-.34-.16-.7-.25-1.1-.27-.4-.01-.79.05-1.18.19-.32.12-.53.26-.6.42s-.06.31.04.46c.1.15.26.29.46.41l.22.13c.27.16.56.28.87.35.31.08.62.11.94.09.32-.01.61-.07.89-.18.29-.11.49-.22.59-.35.1-.12.13-.25.09-.37-.04-.12-.14-.23-.28-.33Z"
            />
            <path
              fill="#28195a"
              d="M277.85,476.3l.59-.22-.03-.02c-.18-.04-.36-.12-.54-.23l-.93-.55c-.22-.12-.48-.19-.78-.19-.3,0-.6.05-.9.16-.2.07-.35.16-.46.25-.11.09-.15.19-.15.28s.07.17.18.23l.58-.21c-.08-.05-.11-.1-.08-.16.03-.06.11-.12.24-.16.14-.05.28-.07.42-.07.14,0,.26.05.37.11l.14.08-.35.13c-.37.14-.6.28-.69.42-.09.14-.02.28.2.41.11.07.25.11.42.14.17.03.34.03.53.02.18-.02.36-.05.52-.11.27-.1.42-.23.44-.39.11.05.2.08.27.09ZM276.2,476.32c-.23-.14-.13-.28.3-.44l.29-.11.38.23c.03.06.02.12-.04.19-.05.06-.14.12-.26.16-.12.04-.24.06-.36.06s-.23-.03-.32-.08Z"
            />
            <path
              fill="#28195a"
              d="M280.16,474.49l-.03-.02c-.33-.19-.68-.32-1.04-.36-.36-.04-.7-.01-1.01.1-.28.1-.42.23-.42.39l-1.06-.63-.58.21,2.91,1.72.52-.19-.2-.14c.35.04.67,0,.96-.1.3-.11.45-.26.44-.43-.01-.18-.18-.36-.5-.55ZM278.91,475.34l-.85-.5c-.03-.07-.03-.13.02-.19.05-.06.13-.11.24-.15.37-.14.78-.07,1.23.19.24.14.37.26.39.36.03.1-.06.19-.24.26-.24.09-.51.1-.78.04Z"
            />
            <path
              fill="#28195a"
              d="M279.34,472.96l-.58.21,2.91,1.72.58-.21-2.91-1.72Z"
            />
            <path
              fill="#28195a"
              d="M280.27,472.93c.07.04.16.07.27.07.1,0,.21-.01.31-.05.1-.04.16-.08.17-.13.02-.05-.01-.1-.09-.14s-.16-.07-.27-.07c-.11,0-.21.01-.31.05-.1.04-.16.08-.17.13-.01.05.02.1.09.14ZM281.43,473.02l-.58.21,2.05,1.21.58-.21-2.05-1.21Z"
            />
            <path
              fill="#28195a"
              d="M282.04,472.79l2.05,1.21.58-.21-1.46-.86c-.03-.06-.03-.13.02-.19.04-.06.12-.11.23-.15.16-.06.31-.08.43-.07.13.01.26.05.4.13l1.33.79.58-.21-1.34-.79c-.5-.29-1.02-.34-1.55-.15-.31.11-.47.26-.46.45l-.27-.14-.54.2Z"
            />
            <path
              fill="#28195a"
              d="M285.62,472.43h.02c.21.14.45.24.69.3.25.06.49.09.73.09.24,0,.46-.04.66-.12.27-.1.41-.23.43-.38l.13.08c.16.1.24.19.22.28-.02.09-.13.17-.33.24-.25.09-.55.12-.89.09v.26c.2.03.41.03.65,0,.23-.03.45-.08.63-.15.27-.1.45-.21.53-.32.09-.12.1-.23.05-.33-.05-.11-.15-.2-.29-.28l-1.99-1.17-.52.19.18.13c-.33-.04-.64,0-.93.11-.2.07-.34.17-.41.27-.07.11-.07.22,0,.34.07.12.21.25.42.37ZM286.26,472.24c-.23-.14-.36-.26-.38-.37-.02-.11.06-.2.25-.27.22-.08.47-.1.73-.05l.91.54c.05.13-.04.24-.27.33-.18.07-.38.09-.6.05-.22-.03-.43-.11-.64-.23Z"
            />
            <path
              fill="#28195a"
              d="M287.94,469.94l2.76,1.63.6-.22-.9-.53-1.28-.7,3.13.88.43-.16-1.12-1.63,1.16.74.9.53.6-.22-2.76-1.63-.78.29,1.15,1.61-3.1-.89-.79.29Z"
            />
            <path
              fill="#28195a"
              d="M296.02,469.65c.21-.08.36-.17.47-.27.1-.1.14-.21.12-.32l-.54-.03c0,.16-.13.29-.39.38-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.2.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM294.12,469.14c-.14-.1-.2-.2-.19-.29.01-.09.09-.16.25-.22.16-.06.32-.08.49-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M298.6,468.7c.21-.08.36-.17.47-.27.1-.1.14-.21.13-.32l-.54-.03c0,.16-.13.29-.39.39-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.2.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM296.7,468.19c-.14-.1-.2-.2-.19-.29.01-.09.09-.16.25-.22.16-.06.32-.08.49-.07s.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M297.6,466.58l.5.3-.41.15.34.2.41-.15,1.17.69c.39.23.8.26,1.25.1.13-.05.24-.1.33-.17l-.35-.21s-.11.06-.18.09c-.1.04-.19.05-.26.05-.07,0-.15-.03-.24-.08l-1.14-.67.45-.17-.34-.2-.45.17-.5-.3-.58.21Z"
            />
            <path
              fill="#28195a"
              d="M302.48,466.69c.08.05.1.1.06.15-.04.06-.13.11-.27.16-.16.06-.31.09-.47.09-.15,0-.29-.03-.4-.09l-.56.21c.12.07.29.12.49.15.2.03.41.03.64,0,.22-.03.44-.07.63-.15.2-.07.36-.16.46-.24.1-.09.15-.18.15-.26,0-.09-.07-.17-.19-.24-.15-.09-.34-.14-.56-.15-.22,0-.49.02-.81.09-.1.02-.15.03-.17.03-.2.04-.37.07-.51.08-.13.01-.24,0-.32-.05-.08-.05-.1-.1-.07-.15.03-.06.11-.11.23-.16.13-.05.27-.07.41-.07.14,0,.25.03.35.09l.58-.21c-.13-.07-.28-.13-.47-.15-.18-.03-.38-.03-.59,0-.21.02-.42.07-.62.15-.19.07-.33.15-.43.24-.09.09-.14.17-.13.26.01.09.07.16.19.23.15.09.35.14.6.14.25,0,.55-.04.9-.12.24-.05.42-.08.55-.09.13,0,.23.02.32.07Z"
            />
            <path
              fill="#28195a"
              d="M305.67,464.5l-1.41.52-.76-.45,1.63-.6-.38-.23-2.23.82,2.76,1.63,2.25-.83-.38-.23-1.65.61-.85-.5,1.4-.52-.38-.22Z"
            />
            <path
              fill="#28195a"
              d="M306.34,463.84l-.63.23,1.78.31.24.91.63-.23-.19-.6,1.22.23.63-.23-1.84-.32-.24-.88-.63.23.19.58-1.16-.22Z"
            />
            <path
              fill="#28195a"
              d="M311.03,463.76c-.19.07-.39.09-.6.06-.21-.03-.42-.11-.64-.24l-.06-.03c-.44-.26-.47-.47-.1-.6.14-.05.3-.07.47-.06.17,0,.32.05.44.12l.54-.2c-.16-.09-.34-.15-.54-.19-.21-.04-.42-.05-.64-.03-.22.02-.43.07-.63.14-.24.09-.4.19-.49.31-.09.12-.1.24-.03.36.07.12.2.25.4.37l.04.03c.33.19.69.31,1.08.34.39.03.77-.01,1.13-.14.19-.07.34-.16.43-.25.09-.1.13-.19.11-.29-.02-.1-.09-.19-.22-.26l-.54.2c.09.06.13.13.1.2-.03.07-.11.14-.25.19Z"
            />
            <path
              fill="#28195a"
              d="M314,463.02c.21-.08.36-.17.47-.27.1-.1.14-.21.13-.32l-.54-.03c0,.16-.13.29-.39.39-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.66-.62,1.66-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.2.68.26.25.05.52.07.79.05.27-.02.52-.07.77-.16ZM312.11,462.51c-.14-.1-.2-.2-.18-.28.01-.09.09-.16.25-.22.16-.06.32-.08.5-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M313.12,460.51l-.58.21,2.91,1.72.58-.21-2.91-1.72Z"
            />
            <path
              fill="#28195a"
              d="M314.35,460.06l-.58.21,2.91,1.72.58-.21-2.91-1.72Z"
            />
            <path
              fill="#28195a"
              d="M319.04,461.16c.21-.08.36-.17.47-.27.1-.1.14-.21.13-.32l-.54-.03c0,.16-.13.29-.39.38-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.2.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM317.15,460.65c-.14-.1-.2-.2-.18-.28.01-.09.09-.16.25-.22.16-.06.32-.08.5-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M318.4,459.39l2.05,1.21.58-.21-1.45-.86c-.03-.06-.03-.13.02-.19.04-.06.12-.11.23-.15.16-.06.3-.08.43-.07.13.01.26.05.4.13l1.33.79.58-.21-1.34-.79c-.5-.29-1.02-.34-1.55-.15-.31.11-.47.26-.46.45l-.27-.14-.54.2Z"
            />
            <path
              fill="#28195a"
              d="M323.85,459.03c-.19.07-.39.09-.6.06-.21-.03-.42-.11-.64-.24l-.06-.03c-.44-.26-.47-.47-.1-.6.14-.05.3-.07.47-.06.17,0,.32.05.44.12l.54-.2c-.16-.09-.34-.15-.54-.19s-.42-.05-.64-.03c-.22.02-.43.07-.63.14-.24.09-.4.19-.49.31-.09.12-.1.24-.03.36.07.12.2.25.4.37l.04.03c.33.19.69.31,1.08.34.39.03.77-.01,1.13-.14.19-.07.33-.16.43-.25.09-.1.13-.19.11-.29-.02-.1-.09-.19-.22-.26l-.54.2c.09.06.13.13.1.2-.03.07-.11.14-.25.19Z"
            />
            <path
              fill="#28195a"
              d="M326.82,458.29c.21-.08.36-.17.47-.27.1-.1.14-.21.13-.32l-.54-.03c0,.16-.13.29-.39.38-.19.07-.39.1-.61.08-.22-.01-.42-.07-.6-.16h-.02s1.67-.62,1.67-.62l-.19-.11c-.32-.19-.67-.3-1.04-.34-.37-.03-.73.01-1.07.14-.23.09-.39.19-.47.31-.08.12-.09.24-.02.37.07.13.2.25.4.37l.06.04c.2.12.43.2.68.26.25.05.52.07.79.05.27-.02.53-.07.77-.16ZM324.92,457.79c-.14-.1-.2-.2-.19-.29s.09-.16.25-.22c.16-.06.32-.08.5-.07.17.01.34.06.49.15l.03.02-1.08.4Z"
            />
            <path
              fill="#28195a"
              d="M325.96,456.56c.15.09.33.15.54.2.21.04.43.06.65.05.22-.01.43-.05.61-.12.18-.07.3-.15.38-.25.07-.1.09-.2.05-.31-.04-.11-.14-.2-.29-.29-.16-.09-.34-.16-.55-.2-.21-.04-.43-.06-.65-.04s-.42.05-.6.12c-.18.07-.31.15-.39.24-.08.1-.1.2-.06.3.04.11.14.21.3.3ZM326.12,456.5c-.14-.09-.23-.17-.26-.26-.03-.09,0-.17.06-.25.07-.08.18-.14.32-.2.15-.06.32-.09.5-.1.18,0,.36,0,.54.04.18.04.33.09.46.17.13.07.21.16.24.25.03.09.02.18-.04.26-.06.08-.17.15-.32.21-.15.06-.32.09-.5.1-.19,0-.37,0-.55-.04s-.33-.09-.46-.17ZM327.05,456.24c.06-.02.12-.03.17-.03.05,0,.1.01.15.04.02,0,.05.02.08.05.08.05.14.08.19.09l.2-.08h-.02s-.05-.03-.08-.04c-.03-.01-.08-.04-.14-.08-.06-.04-.13-.06-.19-.07s-.13-.02-.21,0c.06-.07.05-.13-.04-.18-.09-.05-.2-.08-.33-.08-.13,0-.26.02-.4.08l-.38.14.94.55.2-.07-.37-.22.23-.08ZM326.68,456.24l-.28-.16.19-.07c.09-.03.16-.05.22-.05s.11.02.17.05c.04.02.05.05.03.08-.02.03-.06.06-.13.08l-.2.07Z"
            />
          </g>
        </g>
        <path
          fill="#939598"
          d="M295.12,509.21c-1,0-1.94-.6-2.33-1.59-.5-1.29.13-2.74,1.41-3.24l61.87-24.3c1.28-.5,2.74.13,3.24,1.41.5,1.29-.13,2.74-1.41,3.24l-61.87,24.3c-.3.12-.61.17-.91.17Z"
        />
        <path
          fill="#939598"
          d="M307.61,518.3c-1,0-1.94-.6-2.33-1.59-.5-1.29.13-2.74,1.41-3.24l23.16-9.1c1.29-.5,2.74.13,3.24,1.41.5,1.29-.13,2.74-1.41,3.24l-23.16,9.1c-.3.12-.61.17-.91.17Z"
        />
      </g>
    </g>
  </svg>
);

export const BackupSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.66 16.51"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect
      strokeMiterlimit="10"
      fill="none"
      stroke={resolveColor(accentColor)}
      strokeWidth=".68px"
      x=".34"
      y="10.45"
      width="15.99"
      height="5.75"
      rx=".94"
      ry=".94"
    />
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M2.02,15.08h12.67c.24,0,.44-.21.44-.46v-2.59c0-.25-.2-.46-.44-.46H2.02c-.24,0-.44.21-.44.46v2.59c0,.25.2.46.44.46Z"
      />
      <path
        fill="#fff"
        d="M12.18,13.83h1.45c.09,0,.17-.08.17-.18v-.77c0-.1-.08-.18-.17-.18h-1.45c-.09,0-.17.08-.17.18v.77c0,.1.08.18.17.18Z"
      />
    </g>
    <path
      fill={resolveColor(svgColor)}
      stroke="#fff"
      strokeWidth=".5px"
      strokeMiterlimit="10"
      d="M12.44,5.82c-.29-.37-.83-.43-1.2-.13l-2.06,1.48s0-.01,0-.02V1.2c0-.5-.4-.9-.9-.9s-.9.4-.9.9v5.9s-2.23-1.51-2.23-1.51c-.38-.27-.91-.19-1.19.19-.27.38-.19.91.19,1.19l3.35,2.27c.25.19.56.29.86.29.33,0,.66-.11.92-.34l3.01-2.18c.37-.29.43-.83.13-1.2Z"
    />
  </svg>
);

export const CMSTreeSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3.23 10.07"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <g>
        <path
          fill={resolveColor(accentColor)}
          d="M3.01,0h-1.53c-.12,0-.21.1-.21.21v2.03c0,.12.09.21.21.21h1.53c.12,0,.21-.09.21-.21V.22C3.22.1,3.13,0,3.01,0ZM3.02.22v2.03s-1.55,0-1.55,0V.22s0,0,0,0h1.54Z"
        />
        <g>
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y=".72"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="1.02"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="1.33"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="1.63"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
        </g>
      </g>
      <g>
        <path
          fill={resolveColor(accentColor)}
          d="M3.01,3.81h-1.53c-.12,0-.21.1-.21.21v2.03c0,.12.09.21.21.21h1.53c.12,0,.21-.09.21-.21v-2.03c0-.12-.09-.21-.21-.21ZM3.02,4.02v2.03s-1.55,0-1.55,0v-2.03s0,0,0,0h1.54Z"
        />
        <g>
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="4.53"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="4.83"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="5.13"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="5.44"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
        </g>
      </g>
      <g>
        <path
          fill={resolveColor(accentColor)}
          d="M3.01,7.62h-1.53c-.12,0-.21.1-.21.21v2.03c0,.12.09.21.21.21h1.53c.12,0,.21-.09.21-.21v-2.03c0-.12-.09-.21-.21-.21ZM3.02,7.83v2.03s-1.55,0-1.55,0v-2.03s0,0,0,0h1.54Z"
        />
        <g>
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="8.33"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="8.64"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="8.94"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
          <rect
            opacity=".99"
            fill={resolveColor(svgColor)}
            x="1.69"
            y="9.25"
            width="1.11"
            height=".11"
            rx=".05"
            ry=".05"
          />
        </g>
      </g>
    </g>
    <path
      fill={resolveColor(svgColor)}
      d="M.87,5.07c.07,0,.12-.05.12-.12s-.05-.12-.12-.12H.25V1.29h.62c.07,0,.12-.05.12-.12s-.05-.12-.12-.12H.15s0,0-.01,0c0,0,0,0-.01,0-.07,0-.12.05-.12.12v7.57c0,.07.05.12.12.12,0,0,0,0,.01,0,0,0,0,0,.01,0h.72c.07,0,.12-.05.12-.12s-.05-.12-.12-.12H.25v-3.54h.62Z"
    />
  </svg>
);

export const ProductsSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10.71 11.89"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M.46,2.96h9.79c.14,0,.25-.11.25-.24v-1.32c0-.41-.34-.74-.76-.74H.96C.55.66.21.99.21,1.4v1.32c0,.13.11.24.25.24Z"
    />
    <g>
      <g>
        <rect
          fill="#fff"
          x=".21"
          y="1.36"
          width="10.29"
          height="10.29"
          rx=".77"
          ry=".77"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M9.73,1.15H.98c-.54,0-.98.44-.98.98v8.75c0,.54.44.98.98.98h8.75c.54,0,.98-.44.98-.98V2.13c0-.54-.44-.98-.98-.98ZM10.29,10.88c0,.31-.25.56-.56.56H.98c-.31,0-.56-.25-.56-.56V2.13c0-.31.25-.56.56-.56h8.75c.31,0,.56.25.56.56v8.75Z"
        />
      </g>
      <g>
        <rect
          fill="#fff"
          x="3.32"
          y="2.75"
          width="4.07"
          height="1.06"
          rx=".53"
          ry=".53"
        />
        <path
          fill={resolveColor(svgColor)}
          d="M6.86,4.02h-3.01c-.41,0-.74-.33-.74-.74s.33-.74.74-.74h3.01c.41,0,.74.33.74.74s-.33.74-.74.74ZM3.85,2.96c-.18,0-.32.14-.32.32s.14.32.32.32h3.01c.18,0,.32-.14.32-.32s-.14-.32-.32-.32h-3.01Z"
        />
      </g>
    </g>
  </svg>
);

export const SalesListSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10.66 11.04"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect
      fill="none"
      stroke={resolveColor(accentColor)}
      strokeMiterlimit="10"
      strokeWidth=".63px"
      x=".27"
      y=".31"
      width="10.12"
      height="10.42"
      rx=".6"
      ry=".6"
    />
    <g>
      <path
        fill={resolveColor(svgColor)}
        d="M5.64,5.84h-.63v.32c-.76.23-.83,1.16-.11,1.48.2.09.3.07.5.1.33.05.32.5-.03.53-.21.02-.33-.09-.36-.26h-.61c0,.33.25.64.61.75v.31s.03.02.06.02c.11.01.41.01.52,0,.02,0,.04,0,.06-.02v-.31c.54-.16.78-.71.5-1.15-.13-.2-.37-.36-.63-.4-.2-.03-.4.02-.48-.2-.15-.39.59-.51.61-.08h.61c.02-.34-.25-.66-.61-.76v-.32Z"
      />
      <g>
        <rect
          fill={resolveColor(svgColor)}
          x="2.56"
          y="2.21"
          width="5.54"
          height=".41"
          rx=".21"
          ry=".21"
        />
        <rect
          fill={resolveColor(svgColor)}
          x="2.56"
          y="3.39"
          width="5.54"
          height=".41"
          rx=".21"
          ry=".21"
        />
        <rect
          fill={resolveColor(svgColor)}
          x="2.56"
          y="4.58"
          width="5.54"
          height=".41"
          rx=".21"
          ry=".21"
        />
      </g>
    </g>
  </svg>
);

export const SelectSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.06 24.03"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(svgColor)}
      d="M23.09,4.53h-2.46s0-2.46,0-2.46c0-.53-.43-.97-.97-.97s-.97.43-.97.97v2.46s-2.46,0-2.46,0c-.53,0-.97.43-.97.97s.43.97.97.97h2.46s0,2.46,0,2.46c0,.53.43.97.97.97s.97-.43.97-.97v-2.46s2.46,0,2.46,0c.53,0,.97-.43.97-.97s-.43-.97-.97-.97Z"
    />
    <path
      fill={resolveColor(accentColor)}
      d="M18.55,24.03H1.86c-1.02,0-1.86-.83-1.86-1.86V1.95C0,.88.88,0,1.95,0h14.29c.41,0,.75.34.75.75s-.34.75-.75.75H1.95c-.25,0-.45.2-.45.45v20.22c0,.2.16.36.36.36h16.7c.2,0,.36-.16.36-.36v-9.89c0-.41.34-.75.75-.75s.75.34.75.75v9.89c0,1.02-.83,1.86-1.86,1.86Z"
    />
  </svg>
);

export const StaticPagesSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.96 6.97"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M7.26,6.97H.68C.3,6.97-.01,6.66-.01,6.27V.7C-.01.32.3,0,.68,0h6.58c.38,0,.7.31.7.7v5.57c0,.38-.31.7-.7.7ZM.68.45c-.14,0-.25.11-.25.25v5.57c0,.14.11.25.25.25h6.58c.14,0,.25-.11.25-.25V.7c0-.14-.11-.25-.25-.25H.68Z"
    />
    <g>
      <circle fill={resolveColor(svgColor)} cx="1.26" cy="1.12" r=".22" />
      <circle fill={resolveColor(svgColor)} cx="1.99" cy="1.12" r=".22" />
      <circle fill={resolveColor(svgColor)} cx="2.72" cy="1.12" r=".22" />
    </g>
    <rect
      fill={resolveColor(accentColor)}
      x=".3"
      y="1.73"
      width="7.34"
      height=".44"
    />
    <g>
      <rect
        fill={resolveColor(accentColor)}
        x="1.26"
        y="3.08"
        width="1.52"
        height="2.45"
        rx=".17"
        ry=".17"
      />
      <g>
        <rect
          opacity=".99"
          fill={resolveColor(svgColor)}
          x="3.51"
          y="3.38"
          width="3.03"
          height=".24"
          rx=".12"
          ry=".12"
        />
        <rect
          opacity=".99"
          fill={resolveColor(svgColor)}
          x="3.51"
          y="4.19"
          width="3.03"
          height=".24"
          rx=".12"
          ry=".12"
        />
        <rect
          opacity=".99"
          fill={resolveColor(svgColor)}
          x="3.51"
          y="5"
          width="3.03"
          height=".24"
          rx=".12"
          ry=".12"
        />
      </g>
    </g>
  </svg>
);

export const TagsSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.54 10.59"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <path
        fill={resolveColor(svgColor)}
        d="M2.08,1.83h2.37c.15,0,.26-.13.26-.3h0c0-.17-.12-.3-.26-.3h-2.37c-.15,0-.26.13-.26.3h0c0,.17.12.3.26.3Z"
      />
      <path
        fill={resolveColor(svgColor)}
        d="M2.43,2.8h1.68c.21,0,.37-.13.37-.3h0c0-.17-.17-.3-.37-.3h-1.68c-.21,0-.37.13-.37.3h0c0,.17.17.3.37.3Z"
      />
    </g>
    <path
      fill="none"
      stroke={resolveColor(accentColor)}
      strokeMiterlimit="10"
      strokeWidth=".47px"
      d="M.29,4.06l2.11,3.74c.04.07.06.15.06.24v1.84c0,.2.17.37.37.37h1.03c.2,0,.37-.17.37-.37v-1.84c0-.08.02-.16.06-.23l1.98-3.76c.17-.32-.06-.71-.43-.71H.71c-.37,0-.6.4-.42.72Z"
    />
  </svg>
);

export const ArticlesSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.96 10.13"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={resolveColor(accentColor)}
      d="M7.27,10.11H.69C.31,10.11,0,9.8,0,9.41V.72C0,.33.31.02.69.02h6.58c.38,0,.7.31.7.7v8.7c0,.38-.31.7-.7.7ZM.69.47c-.14,0-.25.11-.25.25v8.7c0,.14.11.25.25.25h6.58c.14,0,.25-.11.25-.25V.72c0-.14-.11-.25-.25-.25H.69Z"
    />
    <g>
      <rect
        opacity=".99"
        fill={resolveColor(svgColor)}
        x="3.04"
        y="3.03"
        width="3.57"
        height=".46"
        rx=".23"
        ry=".23"
      />
      <rect
        opacity=".99"
        fill={resolveColor(svgColor)}
        x="1.84"
        y="7.92"
        width="3.57"
        height=".46"
        rx=".23"
        ry=".23"
      />
      <rect
        opacity=".99"
        fill={resolveColor(svgColor)}
        x="1.84"
        y="4.25"
        width="4.76"
        height=".46"
        rx=".23"
        ry=".23"
      />
      <rect
        opacity=".99"
        fill={resolveColor(svgColor)}
        x="1.84"
        y="5.48"
        width="4.76"
        height=".46"
        rx=".23"
        ry=".23"
      />
      <rect
        opacity=".99"
        fill={resolveColor(svgColor)}
        x="1.84"
        y="6.7"
        width="4.76"
        height=".46"
        rx=".23"
        ry=".23"
      />
      <path
        fill={resolveColor(svgColor)}
        d="M2.74,1.75h-1.34s-.04.02-.04.04v.26s.02.04.04.04h.46v1.35s.02.04.04.04h.33s.04-.02.04-.04v-1.35h.47s.04-.02.04-.04v-.26s-.02-.04-.04-.04Z"
      />
    </g>
  </svg>
);

export const ReferencesSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.5 7.86"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <rect
        fill="#fff"
        x=".52"
        y=".43"
        width="4.13"
        height="4.97"
        rx=".22"
        ry=".22"
        transform="translate(-.48 .52) rotate(-10.43)"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M4.87,5.16l-3.63.67c-.19.04-.38-.09-.42-.29L0,1.09c-.04-.2.09-.38.29-.42l3.63-.67c.2-.04.38.09.42.29l.82,4.45c.04.19-.09.38-.29.42ZM.34.94s-.07.05-.07.1l.82,4.45s.05.07.1.07l3.63-.67s.08-.05.07-.1L4.07.34s-.05-.08-.1-.07L.34.94Z"
      />
    </g>
    <g>
      <g>
        <rect
          fill="#fff"
          x="1.87"
          y="1.28"
          width="4.13"
          height="4.97"
          rx=".22"
          ry=".22"
        />
        <path
          fill={resolveColor(accentColor)}
          d="M5.77,6.39h-3.69c-.2,0-.36-.16-.36-.36V1.51c0-.2.16-.36.36-.36h3.69c.2,0,.36.16.36.36v4.53c0,.2-.16.36-.36.36ZM2.09,1.42s-.08.04-.08.08v4.53s.04.08.08.08h3.69s.08-.04.08-.08V1.51s-.04-.08-.08-.08h-3.69Z"
        />
      </g>
      <g>
        <rect
          fill={resolveColor(accentColor)}
          x="2.58"
          y="2.45"
          width="2.69"
          height=".26"
          rx=".13"
          ry=".13"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="2.58"
          y="3.25"
          width="2.69"
          height=".26"
          rx=".13"
          ry=".13"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="2.58"
          y="4.04"
          width="2.69"
          height=".26"
          rx=".13"
          ry=".13"
        />
        <rect
          fill={resolveColor(accentColor)}
          x="2.58"
          y="4.83"
          width="2.69"
          height=".26"
          rx=".13"
          ry=".13"
        />
      </g>
    </g>
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M6.17,6.81h1.17c.19,0,.35.16.35.35h0c0,.19-.16.35-.35.35h-1.17v-.7h0Z"
        transform="translate(9.34 -2.51) rotate(58.07)"
      />
      <circle
        stroke={resolveColor(svgColor)}
        strokeMiterlimit="10"
        strokeWidth=".47px"
        fill="#fff"
        cx="5.89"
        cy="5.4"
        r="1.38"
      />
    </g>
  </svg>
);

export const ProductListsSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.28 6.97"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect
      fill={resolveColor(accentColor)}
      x="1.97"
      y=".53"
      width="5.31"
      height=".46"
      rx=".23"
      ry=".23"
    />
    <rect
      fill={resolveColor(svgColor)}
      opacity=".99"
      y=".02"
      width="1.36"
      height="1.48"
      rx=".15"
      ry=".15"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="1.97"
      y="3.23"
      width="5.31"
      height=".46"
      rx=".23"
      ry=".23"
    />
    <rect
      fill={resolveColor(svgColor)}
      opacity=".99"
      y="2.72"
      width="1.36"
      height="1.48"
      rx=".15"
      ry=".15"
    />
    <rect
      fill={resolveColor(accentColor)}
      x="1.97"
      y="5.99"
      width="5.31"
      height=".46"
      rx=".23"
      ry=".23"
    />
    <rect
      fill={resolveColor(svgColor)}
      opacity=".99"
      y="5.47"
      width="1.36"
      height="1.48"
      rx=".15"
      ry=".15"
    />
  </svg>
);

export const LeadManagementSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10.36 8.71"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M1.97,1.38c.75-.05,1.37.58,1.33,1.33-.04.62-.54,1.12-1.16,1.16-.75.05-1.37-.58-1.33-1.33.04-.62.54-1.13,1.16-1.16Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M2.05,6.16c-.74,0-1.41-.28-1.92-.73-.16-.14-.18-.37-.05-.54.24-.31.54-.57.9-.74.16-.08.34-.07.5,0,.18.09.38.13.58.13s.4-.04.58-.13c.16-.08.34-.08.5,0,.35.17.66.43.9.74.13.17.1.4-.05.54-.51.45-1.18.73-1.92.73Z"
      />
    </g>
    <g>
      <path
        fill={resolveColor(svgColor)}
        d="M5.97,0c1.21-.08,2.21.92,2.13,2.14-.06,1-.87,1.81-1.87,1.87-1.21.08-2.21-.92-2.13-2.13C4.17.88,4.97.07,5.97,0Z"
      />
      <g>
        <path
          fill={resolveColor(svgColor)}
          d="M6.11,8.5c-1.45,0-2.78-.55-3.79-1.45-.31-.27-.36-.74-.11-1.07.47-.62,1.08-1.12,1.77-1.46.31-.15.67-.15.98,0,.36.17.74.26,1.14.26s.78-.09,1.14-.26c.32-.15.68-.16.98,0,.7.34,1.31.84,1.77,1.46.25.33.2.79-.11,1.07-1.01.9-2.33,1.45-3.79,1.45Z"
        />
        <path
          fill="#fff"
          d="M6.11,8.7c-1.45,0-2.84-.53-3.92-1.49-.39-.35-.44-.92-.13-1.33.49-.65,1.12-1.17,1.84-1.52.36-.17.78-.17,1.15,0,.66.32,1.45.32,2.11,0,.37-.18.79-.18,1.15,0,.72.35,1.36.88,1.84,1.52.31.41.25.99-.13,1.33-1.08.96-2.47,1.5-3.92,1.5ZM4.46,4.62c-.13,0-.27.03-.39.09-.66.32-1.25.81-1.7,1.4-.19.25-.15.59.08.8,1.01.9,2.31,1.39,3.66,1.39s2.65-.5,3.66-1.4c.23-.21.27-.55.08-.8-.45-.59-1.04-1.08-1.7-1.4-.25-.12-.54-.12-.81,0-.77.37-1.68.37-2.45,0-.13-.06-.28-.1-.42-.1Z"
        />
      </g>
    </g>
  </svg>
);

export const UserManagementSVG = ({
  className,
  svgColor = "pinkCustom",
  accentColor = "#808285",
}: {
  className?: string;
  svgColor?: string;
  accentColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.64 13.8"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M14.56,3.45c1.09-.07,1.99.83,1.92,1.92-.06.9-.78,1.63-1.68,1.68-1.09.07-1.98-.83-1.92-1.92.06-.9.78-1.63,1.68-1.68Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M14.68,10.36c-1.06,0-2.03-.4-2.77-1.06-.22-.2-.26-.54-.08-.78.34-.45.79-.82,1.29-1.07.22-.11.49-.11.72,0,.26.13.54.19.83.19s.57-.06.83-.19c.23-.11.49-.11.72,0,.51.25.95.62,1.29,1.07.18.24.15.58-.08.78-.74.66-1.7,1.06-2.77,1.06Z"
      />
    </g>
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M2.84,3.45c1.09-.07,1.99.83,1.92,1.92-.06.9-.78,1.63-1.68,1.68-1.09.07-1.98-.83-1.92-1.92.06-.9.78-1.63,1.68-1.68Z"
      />
      <path
        fill={resolveColor(accentColor)}
        d="M2.96,10.36c-1.06,0-2.03-.4-2.77-1.06-.22-.2-.26-.54-.08-.78.34-.45.79-.82,1.29-1.07.22-.11.49-.11.72,0,.26.13.54.19.83.19s.57-.06.83-.19c.23-.11.49-.11.72,0,.51.25.95.62,1.29,1.07.18.24.15.58-.08.78-.74.66-1.7,1.06-2.77,1.06Z"
      />
    </g>
    <g>
      <path
        fill={resolveColor(accentColor)}
        d="M8.59.07c2.15-.14,3.93,1.64,3.79,3.8-.11,1.78-1.55,3.21-3.32,3.33-2.15.14-3.93-1.64-3.79-3.79.11-1.78,1.55-3.22,3.32-3.33Z"
      />
      <g>
        <path
          fill={resolveColor(svgColor)}
          d="M8.82,13.64c-2,0-3.92-.73-5.41-2.06-.41-.37-.47-.97-.14-1.41.67-.89,1.54-1.61,2.52-2.08.2-.1.42-.15.65-.15s.46.05.68.16c.53.26,1.1.39,1.69.39s1.16-.13,1.69-.39c.22-.1.45-.16.68-.16s.45.05.65.15c.98.48,1.86,1.2,2.52,2.08.33.44.27,1.04-.14,1.41-1.49,1.33-3.41,2.06-5.41,2.06Z"
        />
        <path
          fill="#fff"
          d="M11.2,8.03h0c.21,0,.42.05.61.14.97.47,1.83,1.18,2.49,2.05.3.39.24.94-.13,1.27-1.47,1.31-3.37,2.04-5.34,2.04s-3.87-.72-5.34-2.04c-.37-.33-.43-.88-.13-1.27.66-.87,1.52-1.58,2.49-2.05.19-.09.39-.14.61-.14s.44.05.64.15c.54.26,1.13.39,1.74.39s1.19-.13,1.74-.39c.21-.1.42-.15.64-.15M11.2,7.83c-.25,0-.49.06-.73.17-.52.25-1.07.38-1.65.38s-1.13-.13-1.65-.38c-.23-.11-.48-.17-.73-.17s-.48.05-.69.16c-1,.49-1.89,1.22-2.56,2.11-.36.48-.29,1.14.16,1.54,1.46,1.3,3.37,2.09,5.47,2.09s4.02-.79,5.47-2.09c.44-.4.51-1.07.16-1.54-.67-.89-1.55-1.63-2.56-2.11-.22-.11-.45-.16-.69-.16h0Z"
        />
      </g>
    </g>
  </svg>
);
